(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2521],{

/***/ 33216:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__(18424);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 18424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$$default": function() { return /* binding */ $$default; },
  "Styles": function() { return /* binding */ about_bs_Styles; },
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ $$default; },
  "make": function() { return /* binding */ about_bs_make; }
});

// EXTERNAL MODULE: ./src/bindings/BsCss.bs.js + 1 modules
var BsCss_bs = __webpack_require__(71863);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./src/css/Theme.bs.js
var Theme_bs = __webpack_require__(93802);
// EXTERNAL MODULE: ./src/components/library/SeoMeta.bs.js
var SeoMeta_bs = __webpack_require__(81036);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Array.js
var belt_Array = __webpack_require__(96533);
// EXTERNAL MODULE: ./src/common/util.bs.js
var util_bs = __webpack_require__(7667);
// EXTERNAL MODULE: ./src/bindings/Fresnel.bs.js
var Fresnel_bs = __webpack_require__(7545);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
// EXTERNAL MODULE: ./src/components/StaticImage.bs.js
var StaticImage_bs = __webpack_require__(30369);
// EXTERNAL MODULE: ./src/config/Localization.bs.js
var Localization_bs = __webpack_require__(98765);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/about/AboutHeader.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE








var container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* backgroundImage */.NxW({
        NAME: "url",
        VAL: "/images/about/about_header_new.png"
    }),
    tl: {
        hd: BsCss_bs/* backgroundRepeat */.FDc("noRepeat"),
        tl: {
            hd: BsCss_bs/* backgroundPosition */.k0m("center"),
            tl: {
                hd: BsCss_bs/* backgroundSize */.G4q("cover"),
                tl: {
                    hd: BsCss_bs/* position */.FKU("relative"),
                    tl: {
                        hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(700)),
                        tl: {
                            hd: BsCss_bs/* media */.BC2("(max-width: 767px)", {
                                hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(570)),
                                tl: {
                                    hd: BsCss_bs/* overflow */.txR("hidden"),
                                    tl: /* [] */ 0
                                }
                            }),
                            tl: {
                                hd: BsCss_bs/* media */.BC2("(min-width: 768px) and (max-width: 1023px)", {
                                    hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(750)),
                                    tl: /* [] */ 0
                                }),
                                tl: {
                                    hd: BsCss_bs/* media */.BC2("(min-width: 1024px) and (max-width: 1280px)", {
                                        hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(563)),
                                        tl: /* [] */ 0
                                    }),
                                    tl: /* [] */ 0
                                }
                            }
                        }
                    }
                }
            }
        }
    }
});
var waveImage = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* position */.FKU("absolute"),
    tl: {
        hd: BsCss_bs/* height */.Cb8(BsCss_bs/* pct */.hdZ(100.0)),
        tl: {
            hd: BsCss_bs/* important */.efO(BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(100.0))),
            tl: {
                hd: BsCss_bs/* media */.BC2("(max-width: 500px)", {
                    hd: BsCss_bs/* important */.efO(BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(130.0))),
                    tl: {
                        hd: BsCss_bs/* marginLeft */.oIA(BsCss_bs.px(-60)),
                        tl: /* [] */ 0
                    }
                }),
                tl: {
                    hd: BsCss_bs/* media */.BC2("(min-width: 501px) and (max-width: 600px)", {
                        hd: BsCss_bs/* important */.efO(BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(130.0))),
                        tl: {
                            hd: BsCss_bs/* marginLeft */.oIA(BsCss_bs.px(-70)),
                            tl: /* [] */ 0
                        }
                    }),
                    tl: {
                        hd: BsCss_bs/* media */.BC2("(min-width: 600px) and (max-width: 767px)", {
                            hd: BsCss_bs/* important */.efO(BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(125.0))),
                            tl: {
                                hd: BsCss_bs/* marginLeft */.oIA(BsCss_bs.px(-90)),
                                tl: /* [] */ 0
                            }
                        }),
                        tl: {
                            hd: BsCss_bs/* selector */.nZE("span > img", {
                                hd: BsCss_bs/* important */.efO(BsCss_bs/* height */.Cb8("inherit_")),
                                tl: /* [] */ 0
                            }),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }
    }
});
var innerContent = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* media */.BC2("(max-width: 768px)", {
        hd: BsCss_bs/* marginLeft */.oIA(BsCss_bs.px(20)),
        tl: {
            hd: BsCss_bs/* marginRight */.wzR(BsCss_bs.px(20)),
            tl: /* [] */ 0
        }
    }),
    tl: {
        hd: BsCss_bs/* media */.BC2("(min-width: 1024px)", {
            hd: BsCss_bs/* marginLeft */.oIA(BsCss_bs.px(30)),
            tl: {
                hd: BsCss_bs/* marginRight */.wzR(BsCss_bs.px(30)),
                tl: {
                    hd: BsCss_bs/* display */.jfB("flex"),
                    tl: {
                        hd: BsCss_bs/* alignItems */.cq$("center"),
                        tl: {
                            hd: BsCss_bs/* height */.Cb8(BsCss_bs/* pct */.hdZ(100.0)),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }),
        tl: {
            hd: BsCss_bs/* media */.BC2("(min-width: 1280px)", {
                hd: BsCss_bs/* marginLeft */.oIA("auto"),
                tl: {
                    hd: BsCss_bs/* marginRight */.wzR("auto"),
                    tl: {
                        hd: BsCss_bs/* maxWidth */.kkr(BsCss_bs.px(1200)),
                        tl: /* [] */ 0
                    }
                }
            }),
            tl: /* [] */ 0
        }
    }
});
var leftContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* media */.BC2("(min-width: 1200px)", {
        hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(50.0)),
        tl: /* [] */ 0
    }),
    tl: {
        hd: BsCss_bs/* media */.BC2("(min-width: 1024px) and (max-width: 1439px)", {
            hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(50.0)),
            tl: /* [] */ 0
        }),
        tl: {
            hd: BsCss_bs/* media */.BC2("(min-width: 1440px)", {
                hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(60.0)),
                tl: /* [] */ 0
            }),
            tl: /* [] */ 0
        }
    }
});
var rightContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* media */.BC2("(max-width: 767px)", {
        hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(90.0)),
        tl: {
            hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(-21)),
            tl: /* [] */ 0
        }
    }),
    tl: {
        hd: BsCss_bs/* media */.BC2("(min-width: 768px) and (max-width: 1023px)", {
            hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(90.0)),
            tl: {
                hd: BsCss_bs/* marginLeft */.oIA("auto"),
                tl: {
                    hd: BsCss_bs/* marginRight */.wzR("auto"),
                    tl: /* [] */ 0
                }
            }
        }),
        tl: {
            hd: BsCss_bs/* media */.BC2("(min-width: 1024px) and (max-width: 1439px)", {
                hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(50.0)),
                tl: {
                    hd: BsCss_bs/* height */.Cb8(BsCss_bs/* pct */.hdZ(100.0)),
                    tl: /* [] */ 0
                }
            }),
            tl: {
                hd: BsCss_bs/* media */.BC2("(min-width: 1440px)", {
                    hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(40.0)),
                    tl: /* [] */ 0
                }),
                tl: /* [] */ 0
            }
        }
    }
});
var aboutText = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* position */.FKU("relative"),
    tl: {
        hd: BsCss_bs/* color */.$_Y(BsCss_bs/* hex */.$v1("FFFFFF")),
        tl: {
            hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(52)),
            tl: {
                hd: BsCss_bs/* fontWeight */.Ue2({
                    NAME: "num",
                    VAL: 500
                }),
                tl: {
                    hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(64)),
                    tl: {
                        hd: BsCss_bs/* maxWidth */.kkr(BsCss_bs.px(1000)),
                        tl: {
                            hd: BsCss_bs/* marginTop */.E9m("auto"),
                            tl: {
                                hd: BsCss_bs/* marginBottom */.yl7("auto"),
                                tl: {
                                    hd: BsCss_bs/* media */.BC2("(max-width: 767px)", {
                                        hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(32)),
                                        tl: {
                                            hd: BsCss_bs/* fontWeight */.Ue2({
                                                NAME: "num",
                                                VAL: 400
                                            }),
                                            tl: {
                                                hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(40)),
                                                tl: {
                                                    hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(54)),
                                                    tl: {
                                                        hd: BsCss_bs/* textAlign */.ydu("center"),
                                                        tl: /* [] */ 0
                                                    }
                                                }
                                            }
                                        }
                                    }),
                                    tl: {
                                        hd: BsCss_bs/* media */.BC2("(min-width: 768px) and (max-width: 1023px)", {
                                            hd: BsCss_bs/* marginLeft */.oIA(BsCss_bs.px(30)),
                                            tl: {
                                                hd: BsCss_bs/* marginRight */.wzR(BsCss_bs.px(30)),
                                                tl: {
                                                    hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(70)),
                                                    tl: /* [] */ 0
                                                }
                                            }
                                        }),
                                        tl: /* [] */ 0
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
});
var underlineText = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* fontWeight */.Ue2("bold"),
    tl: {
        hd: BsCss_bs/* textDecoration */.QXS("underline"),
        tl: /* [] */ 0
    }
});
var phoneImage = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* position */.FKU("absolute"),
    tl: {
        hd: BsCss_bs/* bottom */.IaC("zero"),
        tl: {
            hd: BsCss_bs/* important */.efO(BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(28.0))),
            tl: {
                hd: BsCss_bs/* media */.BC2("(max-width: 500px)", {
                    hd: BsCss_bs/* important */.efO(BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(70.0))),
                    tl: {
                        hd: BsCss_bs/* position */.FKU("absolute"),
                        tl: {
                            hd: BsCss_bs/* left */.t$v("zero"),
                            tl: /* [] */ 0
                        }
                    }
                }),
                tl: {
                    hd: BsCss_bs/* media */.BC2("(min-width: 501px) and (max-width: 767px)", {
                        hd: BsCss_bs/* important */.efO(BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(60.0))),
                        tl: {
                            hd: BsCss_bs/* position */.FKU("absolute"),
                            tl: {
                                hd: BsCss_bs/* left */.t$v("zero"),
                                tl: /* [] */ 0
                            }
                        }
                    }),
                    tl: {
                        hd: BsCss_bs/* media */.BC2("(min-width: 768px) and (max-width: 1023px)", {
                            hd: BsCss_bs/* important */.efO(BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(50.0))),
                            tl: /* [] */ 0
                        }),
                        tl: {
                            hd: BsCss_bs/* media */.BC2("(min-width: 1024px) and (max-width: 1279px)", {
                                hd: BsCss_bs/* important */.efO(BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(40.0))),
                                tl: /* [] */ 0
                            }),
                            tl: {
                                hd: BsCss_bs/* media */.BC2("(min-width: 1280px) and (max-width: 1440px)", {
                                    hd: BsCss_bs/* important */.efO(BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(40.0))),
                                    tl: /* [] */ 0
                                }),
                                tl: {
                                    hd: BsCss_bs/* media */.BC2("(min-width: 2000px)", {
                                        hd: BsCss_bs/* important */.efO(BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(22.0))),
                                        tl: /* [] */ 0
                                    }),
                                    tl: /* [] */ 0
                                }
                            }
                        }
                    }
                }
            }
        }
    }
});
var Styles = {
    container: container,
    waveImage: waveImage,
    innerContent: innerContent,
    leftContainer: leftContainer,
    rightContainer: rightContainer,
    aboutText: aboutText,
    underlineText: underlineText,
    phoneImage: phoneImage
};
function AboutHeader(props) {
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsxs(jsx_runtime.Fragment, {
                children: [
                    jsx_runtime.jsx(Fresnel_bs/* Media.make */.pU.make, {
                        lessThan: "md",
                        children: jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                            src: "/images/about/mobile_redline.png",
                            alt: "Prezzee Red Line",
                            width: 797,
                            height: 546,
                            className: waveImage,
                            loading: "eager"
                        })
                    }),
                    jsx_runtime.jsx(Fresnel_bs/* Media.make */.pU.make, {
                        greaterThanOrEqual: "md",
                        children: jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                            src: "/images/about/about_background_line.png",
                            alt: "Prezzee Red Line",
                            width: 2880,
                            height: 1278,
                            className: waveImage,
                            loading: "eager"
                        })
                    })
                ]
            }),
            jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsx("div", {
                        children: jsx_runtime.jsxs("h1", {
                            children: [
                                util_bs/* ReactStuff.s */.p_.s("We're on a "),
                                jsx_runtime.jsx("span", {
                                    children: util_bs/* ReactStuff.s */.p_.s("mission"),
                                    className: underlineText
                                }),
                                util_bs/* ReactStuff.s */.p_.s(" to make gift cards fun, "),
                                belt_Option/* mapWithDefault */.k7(Localization_bs/* getLocalizedString */.Z("personalise"), null, util_bs/* ReactStuff.s */.p_.s),
                                util_bs/* ReactStuff.s */.p_.s("d and easy to use!")
                            ],
                            className: aboutText
                        }),
                        className: leftContainer
                    }),
                    jsx_runtime.jsx("div", {
                        children: jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                            src: "/images/about/about_phone.png",
                            alt: "Prezzee About Us",
                            width: 570,
                            height: 590,
                            className: phoneImage,
                            loading: "eager"
                        }),
                        className: rightContainer
                    })
                ],
                className: innerContent
            })
        ],
        className: container
    });
}
var make = AboutHeader;
 /* container Not a pure module */ 

// EXTERNAL MODULE: ./src/components/pages/about/MeetTheTeam.bs.js
var MeetTheTeam_bs = __webpack_require__(3336);
;// CONCATENATED MODULE: ./src/components/pages/about/Text.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE


function $$Text(props) {
    return jsx_runtime.jsx("p", {
        children: props.children,
        className: belt_Option/* getWithDefault */.tj(props.className, "")
    });
}
var Text_bs_make = $$Text;
 /* react/jsx-runtime Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_obj.js
var caml_obj = __webpack_require__(84445);
;// CONCATENATED MODULE: ./src/components/pages/about/shoutAbout/MediaSection.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE








var wrapper = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* backgroundColor */.Czw(Theme_bs/* Color.white */.Il.white),
    tl: {
        hd: BsCss_bs/* backgroundImage */.NxW(BsCss_bs/* url */.HQ2("/images/about/shoutAboutBg.svg")),
        tl: {
            hd: BsCss_bs/* backgroundRepeat */.FDc("noRepeat"),
            tl: {
                hd: BsCss_bs/* backgroundPosition */.k0m("center"),
                tl: {
                    hd: BsCss_bs/* backgroundSize */.G4q("cover"),
                    tl: {
                        hd: BsCss_bs/* height */.Cb8(BsCss_bs/* pct */.hdZ(100.0)),
                        tl: {
                            hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(100.0)),
                            tl: {
                                hd: BsCss_bs/* position */.FKU("relative"),
                                tl: {
                                    hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(20)),
                                    tl: {
                                        hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs.px(20)),
                                        tl: {
                                            hd: BsCss_bs/* margin */.e6$("auto"),
                                            tl: {
                                                hd: BsCss_bs/* media */.BC2("(min-width: 768px)", {
                                                    hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(750)),
                                                    tl: /* [] */ 0
                                                }),
                                                tl: /* [] */ 0
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
});
var innerWrapper = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* bottom */.IaC(BsCss_bs.px(46)),
    tl: {
        hd: BsCss_bs/* left */.t$v(BsCss_bs.px(0)),
        tl: {
            hd: BsCss_bs/* right */.F2z(BsCss_bs.px(0)),
            tl: {
                hd: BsCss_bs/* margin */.e6$("auto"),
                tl: {
                    hd: BsCss_bs/* media */.BC2("(max-width: 480px)", {
                        hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(90.0)),
                        tl: /* [] */ 0
                    }),
                    tl: {
                        hd: BsCss_bs/* media */.BC2("(min-width: 480px) and (max-width: 640px)", {
                            hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(70.0)),
                            tl: /* [] */ 0
                        }),
                        tl: {
                            hd: BsCss_bs/* media */.BC2("(min-width: 640px) and (max-width: 767px)", {
                                hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(55.0)),
                                tl: /* [] */ 0
                            }),
                            tl: {
                                hd: BsCss_bs/* media */.BC2("(min-width: 768px)", {
                                    hd: BsCss_bs/* display */.jfB("flex"),
                                    tl: {
                                        hd: BsCss_bs/* flexDirection */.Me8("row"),
                                        tl: {
                                            hd: BsCss_bs/* justifyContent */.KlP("center"),
                                            tl: {
                                                hd: BsCss_bs/* position */.FKU("absolute"),
                                                tl: /* [] */ 0
                                            }
                                        }
                                    }
                                }),
                                tl: /* [] */ 0
                            }
                        }
                    }
                }
            }
        }
    }
});
var awardContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* marginRight */.wzR(BsCss_bs.px(25)),
    tl: {
        hd: BsCss_bs/* media */.BC2("(min-width: 1440px)", {
            hd: BsCss_bs/* width */.bf$(BsCss_bs.px(370)),
            tl: {
                hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(-180)),
                tl: /* [] */ 0
            }
        }),
        tl: {
            hd: BsCss_bs/* media */.BC2("(min-width: 1280px)", {
                hd: BsCss_bs/* width */.bf$(BsCss_bs.px(340)),
                tl: {
                    hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(-180)),
                    tl: /* [] */ 0
                }
            }),
            tl: {
                hd: BsCss_bs/* media */.BC2("(min-width: 1024px)", {
                    hd: BsCss_bs/* width */.bf$(BsCss_bs.px(308)),
                    tl: {
                        hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(-180)),
                        tl: /* [] */ 0
                    }
                }),
                tl: {
                    hd: BsCss_bs/* media */.BC2("(min-width: 768px)", {
                        hd: BsCss_bs/* width */.bf$(BsCss_bs.px(344)),
                        tl: {
                            hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(-180)),
                            tl: /* [] */ 0
                        }
                    }),
                    tl: {
                        hd: BsCss_bs/* media */.BC2("(max-width: 767px)", {
                            hd: BsCss_bs/* marginRight */.wzR(BsCss_bs.px(0)),
                            tl: {
                                hd: BsCss_bs/* margin */.e6$("auto"),
                                tl: {
                                    hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(19)),
                                    tl: /* [] */ 0
                                }
                            }
                        }),
                        tl: /* [] */ 0
                    }
                }
            }
        }
    }
});
var titleText = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(40)),
    tl: {
        hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(50)),
        tl: {
            hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs.px(30)),
            tl: {
                hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.white */.Il.white),
                tl: {
                    hd: BsCss_bs/* fontWeight */.Ue2("semiBold"),
                    tl: {
                        hd: BsCss_bs/* fontStyle */.p_N("normal"),
                        tl: {
                            hd: BsCss_bs/* media */.BC2("(max-width: 767px)", {
                                hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(32)),
                                tl: {
                                    hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(42)),
                                    tl: {
                                        hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs.px(20)),
                                        tl: {
                                            hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(20)),
                                            tl: /* [] */ 0
                                        }
                                    }
                                }
                            }),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }
    }
});
var imgContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* backgroundColor */.Czw(Theme_bs/* Color.white */.Il.white),
    tl: {
        hd: BsCss_bs/* borderRadius */.E0l(BsCss_bs.px(10)),
        tl: {
            hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(450)),
            tl: {
                hd: BsCss_bs/* media */.BC2("(min-width: 1440px)", {
                    hd: BsCss_bs/* width */.bf$(BsCss_bs.px(370)),
                    tl: /* [] */ 0
                }),
                tl: {
                    hd: BsCss_bs/* media */.BC2("(min-width: 1280px)", {
                        hd: BsCss_bs/* width */.bf$(BsCss_bs.px(340)),
                        tl: /* [] */ 0
                    }),
                    tl: {
                        hd: BsCss_bs/* media */.BC2("(min-width: 1024px)", {
                            hd: BsCss_bs/* width */.bf$(BsCss_bs.px(308)),
                            tl: /* [] */ 0
                        }),
                        tl: {
                            hd: BsCss_bs/* media */.BC2("(min-width: 768px)", {
                                hd: BsCss_bs/* width */.bf$(BsCss_bs.px(344)),
                                tl: /* [] */ 0
                            }),
                            tl: {
                                hd: BsCss_bs/* media */.BC2("(max-width: 767px)", {
                                    hd: BsCss_bs/* margin */.e6$("auto"),
                                    tl: {
                                        hd: BsCss_bs/* height */.Cb8(BsCss_bs/* pct */.hdZ(100.0)),
                                        tl: {
                                            hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs.px(15)),
                                            tl: /* [] */ 0
                                        }
                                    }
                                }),
                                tl: /* [] */ 0
                            }
                        }
                    }
                }
            }
        }
    }
});
var innerContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* marginLeft */.oIA(BsCss_bs.px(18)),
    tl: {
        hd: BsCss_bs/* marginRight */.wzR(BsCss_bs.px(18)),
        tl: {
            hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(18)),
            tl: /* [] */ 0
        }
    }
});
var awardsImgContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("flex"),
    tl: {
        hd: BsCss_bs/* justifyContent */.KlP("spaceBetween"),
        tl: {
            hd: BsCss_bs/* alignItems */.cq$("center"),
            tl: {
                hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(15)),
                tl: /* [] */ 0
            }
        }
    }
});
var img = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* maxWidth */.kkr(BsCss_bs/* pct */.hdZ(30.0)),
    tl: /* [] */ 0
});
var awardsSubTitleText = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(16)),
    tl: {
        hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(64)),
        tl: {
            hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.prezzeeRed */.Il.prezzeeRed),
            tl: {
                hd: BsCss_bs/* fontWeight */.Ue2("normal"),
                tl: {
                    hd: BsCss_bs/* fontStyle */.p_N("normal"),
                    tl: {
                        hd: BsCss_bs/* media */.BC2("(max-width: 480px)", {
                            hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(25)),
                            tl: {
                                hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(30)),
                                tl: /* [] */ 0
                            }
                        }),
                        tl: /* [] */ 0
                    }
                }
            }
        }
    }
});
var mediaSubTitleText = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(16)),
    tl: {
        hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(64)),
        tl: {
            hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.prezzeeRed */.Il.prezzeeRed),
            tl: {
                hd: BsCss_bs/* fontWeight */.Ue2("normal"),
                tl: {
                    hd: BsCss_bs/* fontStyle */.p_N("normal"),
                    tl: {
                        hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(25)),
                        tl: {
                            hd: BsCss_bs/* media */.BC2("(max-width: 480px)", {
                                hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(25)),
                                tl: {
                                    hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(20)),
                                    tl: /* [] */ 0
                                }
                            }),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }
    }
});
var mediaLogo1 = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs.px(96)),
    tl: {
        hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(22)),
        tl: {
            hd: BsCss_bs/* margin */.e6$("auto"),
            tl: {
                hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(33)),
                tl: /* [] */ 0
            }
        }
    }
});
var mediaLogo2 = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs.px(173)),
    tl: {
        hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(22)),
        tl: {
            hd: BsCss_bs/* margin */.e6$("auto"),
            tl: {
                hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(33)),
                tl: /* [] */ 0
            }
        }
    }
});
var mediaLogo3 = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs.px(96)),
    tl: {
        hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(22)),
        tl: {
            hd: BsCss_bs/* margin */.e6$("auto"),
            tl: {
                hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(33)),
                tl: /* [] */ 0
            }
        }
    }
});
var mediaLogo4 = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs.px(135)),
    tl: {
        hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(22)),
        tl: {
            hd: BsCss_bs/* margin */.e6$("auto"),
            tl: {
                hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(33)),
                tl: /* [] */ 0
            }
        }
    }
});
var mediaLogo5 = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs.px(136)),
    tl: {
        hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(22)),
        tl: {
            hd: BsCss_bs/* margin */.e6$("auto"),
            tl: {
                hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(33)),
                tl: /* [] */ 0
            }
        }
    }
});
var mediaLogo6 = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs.px(96)),
    tl: {
        hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(22)),
        tl: {
            hd: BsCss_bs/* margin */.e6$("auto"),
            tl: {
                hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(33)),
                tl: /* [] */ 0
            }
        }
    }
});
var mediaLogo7 = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs.px(201)),
    tl: {
        hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(22)),
        tl: {
            hd: BsCss_bs/* margin */.e6$("auto"),
            tl: {
                hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(33)),
                tl: /* [] */ 0
            }
        }
    }
});
var MediaSection_bs_Styles = {
    wrapper: wrapper,
    innerWrapper: innerWrapper,
    awardContainer: awardContainer,
    titleText: titleText,
    imgContainer: imgContainer,
    innerContainer: innerContainer,
    awardsImgContainer: awardsImgContainer,
    img: img,
    awardsSubTitleText: awardsSubTitleText,
    mediaSubTitleText: mediaSubTitleText,
    mediaLogo1: mediaLogo1,
    mediaLogo2: mediaLogo2,
    mediaLogo3: mediaLogo3,
    mediaLogo4: mediaLogo4,
    mediaLogo5: mediaLogo5,
    mediaLogo6: mediaLogo6,
    mediaLogo7: mediaLogo7
};
function MediaSection(props) {
    return jsx_runtime.jsx("div", {
        children: jsx_runtime.jsxs("div", {
            children: [
                jsx_runtime.jsxs("div", {
                    children: [
                        jsx_runtime.jsxs("h2", {
                            children: [
                                "We've got ",
                                jsx_runtime.jsx("u", {
                                    children: "a lot"
                                }),
                                " to shout about"
                            ],
                            className: titleText
                        }),
                        jsx_runtime.jsx("div", {
                            children: jsx_runtime.jsxs("div", {
                                children: [
                                    jsx_runtime.jsx(Text_bs_make, {
                                        children: "We're award winning...",
                                        className: awardsSubTitleText
                                    }),
                                    jsx_runtime.jsxs("div", {
                                        children: [
                                            jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                                                src: "/images/about/awards/1.png",
                                                alt: "fast starters award",
                                                width: 199,
                                                height: 199,
                                                className: img
                                            }),
                                            jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                                                src: "/images/about/awards/2.png",
                                                alt: "fast 50 award",
                                                width: 199,
                                                height: 199,
                                                className: img
                                            }),
                                            jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                                                src: "/images/about/awards/3.png",
                                                alt: "fast 500 award",
                                                width: 199,
                                                height: 199,
                                                className: img
                                            })
                                        ],
                                        className: awardsImgContainer
                                    }),
                                    jsx_runtime.jsxs("div", {
                                        children: [
                                            jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                                                src: "/images/about/awards/4.png",
                                                alt: "woman in finance award",
                                                width: 199,
                                                height: 199,
                                                className: img
                                            }),
                                            jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                                                src: "/images/about/awards/5.png",
                                                alt: "retailer award 2018",
                                                width: 199,
                                                height: 199,
                                                className: img
                                            }),
                                            jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                                                src: "/images/about/awards/6.png",
                                                alt: "retailer award 2017",
                                                width: 199,
                                                height: 199,
                                                className: img
                                            })
                                        ],
                                        className: awardsImgContainer
                                    }),
                                    jsx_runtime.jsxs("div", {
                                        children: [
                                            jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                                                src: "/images/about/awards/7.png",
                                                alt: "iAwards national merit",
                                                width: 199,
                                                height: 199,
                                                className: img
                                            }),
                                            jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                                                src: "/images/about/awards/8.png",
                                                alt: "iAwards nsw winner",
                                                width: 199,
                                                height: 199,
                                                className: img
                                            }),
                                            jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                                                src: "/images/about/awards/9.png",
                                                alt: "iAwards national winner",
                                                width: 199,
                                                height: 199,
                                                className: img
                                            })
                                        ],
                                        className: awardsImgContainer
                                    })
                                ],
                                className: innerContainer
                            }),
                            className: imgContainer
                        })
                    ],
                    className: awardContainer
                }),
                jsx_runtime.jsx("div", {
                    children: jsx_runtime.jsxs("div", {
                        children: [
                            jsx_runtime.jsx(Text_bs_make, {
                                children: "We've been featured in...",
                                className: mediaSubTitleText
                            }),
                            caml_obj/* equal */.Dg(util_bs/* EnvUtil.currentCountry */.i3.currentCountry, {
                                TAG: /* Ok */ 0,
                                _0: /* UnitedStates */ 2
                            }) ? jsx_runtime.jsx("div", {
                                children: jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                                    src: "/images/about/media/forbes_logo.png",
                                    alt: "forbes logo",
                                    width: 170,
                                    height: 44
                                }),
                                className: mediaLogo1
                            }) : null,
                            jsx_runtime.jsx("div", {
                                children: jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                                    src: "/images/about/media/afr_logo.png",
                                    alt: "afr logo",
                                    width: 520,
                                    height: 66
                                }),
                                className: mediaLogo2
                            }),
                            jsx_runtime.jsx("div", {
                                children: jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                                    src: "/images/about/media/retailbiz.png",
                                    alt: "retailbiz logo",
                                    width: 288,
                                    height: 66
                                }),
                                className: mediaLogo3
                            }),
                            caml_obj/* equal */.Dg(util_bs/* EnvUtil.currentCountry */.i3.currentCountry, {
                                TAG: /* Ok */ 0,
                                _0: /* Australia */ 0
                            }) ? jsx_runtime.jsx("div", {
                                children: jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                                    src: "/images/about/media/herald_sun.png",
                                    alt: "herald sun logo",
                                    width: 405,
                                    height: 66
                                }),
                                className: mediaLogo4
                            }) : null,
                            jsx_runtime.jsx("div", {
                                children: jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                                    src: "/images/about/media/the_telegraph_logo.png",
                                    alt: "the telegraph logo",
                                    width: 408,
                                    height: 66
                                }),
                                className: mediaLogo5
                            }),
                            jsx_runtime.jsx("div", {
                                children: jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                                    src: "/images/about/media/sky_news_logo.png",
                                    alt: "sky news logo",
                                    width: 290,
                                    height: 66
                                }),
                                className: mediaLogo6
                            }),
                            jsx_runtime.jsx("div", {
                                children: jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                                    src: "/images/about/media/sydney_morning_herald_logo.png",
                                    alt: "sydney morning herald logo",
                                    width: 605,
                                    height: 66
                                }),
                                className: mediaLogo7
                            })
                        ],
                        className: innerContainer
                    }),
                    className: imgContainer
                })
            ],
            className: innerWrapper
        }),
        className: wrapper
    });
}
var Img;
var MediaSection_bs_make = MediaSection;
 /* wrapper Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/pages/about/AboutJoinTeam.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





var AboutJoinTeam_bs_container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("flex"),
    tl: {
        hd: BsCss_bs/* justifyContent */.KlP("center"),
        tl: {
            hd: BsCss_bs/* alignItems */.cq$("center"),
            tl: {
                hd: BsCss_bs/* textAlign */.ydu("center"),
                tl: {
                    hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(100)),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var title = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* color */.$_Y(BsCss_bs/* hex */.$v1("313E49")),
    tl: {
        hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(42)),
        tl: {
            hd: BsCss_bs/* fontWeight */.Ue2({
                NAME: "num",
                VAL: 600
            }),
            tl: {
                hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(52)),
                tl: /* [] */ 0
            }
        }
    }
});
var AboutJoinTeam_bs_text = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* color */.$_Y(BsCss_bs/* hex */.$v1("767676")),
    tl: {
        hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(16)),
        tl: {
            hd: BsCss_bs/* fontWeight */.Ue2({
                NAME: "num",
                VAL: 400
            }),
            tl: {
                hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(25)),
                tl: /* [] */ 0
            }
        }
    }
});
var AboutJoinTeam_bs_button = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* color */.$_Y(BsCss_bs/* hex */.$v1("FFFFFF")),
    tl: {
        hd: BsCss_bs/* backgroundColor */.Czw(BsCss_bs/* hex */.$v1("E30B17")),
        tl: {
            hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(16)),
            tl: {
                hd: BsCss_bs/* fontWeight */.Ue2({
                    NAME: "num",
                    VAL: 700
                }),
                tl: {
                    hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(17)),
                    tl: {
                        hd: BsCss_bs/* width */.bf$(BsCss_bs.px(250)),
                        tl: {
                            hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(50)),
                            tl: {
                                hd: BsCss_bs/* borderRadius */.E0l(BsCss_bs.px(10)),
                                tl: {
                                    hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(25)),
                                    tl: {
                                        hd: BsCss_bs/* hover */.MrM({
                                            hd: BsCss_bs/* opacity */.Ohi(0.50),
                                            tl: /* [] */ 0
                                        }),
                                        tl: /* [] */ 0
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
});
var AboutJoinTeam_bs_Styles = {
    container: AboutJoinTeam_bs_container,
    title: title,
    text: AboutJoinTeam_bs_text,
    button: AboutJoinTeam_bs_button
};
function AboutJoinTeam(props) {
    return jsx_runtime.jsx("div", {
        children: jsx_runtime.jsxs("div", {
            children: [
                jsx_runtime.jsx("h1", {
                    children: util_bs/* ReactStuff.s */.p_.s("Want to join the team?"),
                    className: title
                }),
                jsx_runtime.jsx("br", {}),
                jsx_runtime.jsx("p", {
                    children: util_bs/* ReactStuff.s */.p_.s("We're hiring right across the globe!"),
                    className: AboutJoinTeam_bs_text
                }),
                jsx_runtime.jsx("p", {
                    children: util_bs/* ReactStuff.s */.p_.s("Take a look at our latest career opportunities."),
                    className: AboutJoinTeam_bs_text
                }),
                jsx_runtime.jsx((link_default()), {
                    href: "https://boards.greenhouse.io/prezzee",
                    prefetch: false,
                    children: jsx_runtime.jsx("a", {
                        children: jsx_runtime.jsx("button", {
                            children: util_bs/* ReactStuff.s */.p_.s("Join us"),
                            className: AboutJoinTeam_bs_button
                        }),
                        target: "_blank"
                    })
                })
            ]
        }),
        className: AboutJoinTeam_bs_container
    });
}
var Link$1;
var AboutJoinTeam_bs_make = AboutJoinTeam;
 /* container Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/about/ourValue/ValueElement.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





var ValueElement_bs_container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(50)),
    tl: {
        hd: BsCss_bs/* media */.BC2("(max-width: 768px)", {
            hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(24)),
            tl: /* [] */ 0
        }),
        tl: /* [] */ 0
    }
});
var valueIcon = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("block"),
    tl: {
        hd: BsCss_bs/* width */.bf$(BsCss_bs.px(50)),
        tl: {
            hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(50)),
            tl: {
                hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(12)),
                tl: /* [] */ 0
            }
        }
    }
});
var brandText = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(22)),
    tl: {
        hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(28)),
        tl: {
            hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.prezzeeRed */.Il.prezzeeRed),
            tl: {
                hd: BsCss_bs/* fontWeight */.Ue2("light"),
                tl: {
                    hd: BsCss_bs/* fontStyle */.p_N("normal"),
                    tl: {
                        hd: BsCss_bs/* display */.jfB("inlineBlock"),
                        tl: {
                            hd: BsCss_bs/* paddingRight */.WLm(BsCss_bs.px(5)),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }
    }
});
var ValueElement_bs_titleText = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(22)),
    tl: {
        hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(28)),
        tl: {
            hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.charcoal */.Il.charcoal),
            tl: {
                hd: BsCss_bs/* fontWeight */.Ue2("semiBold"),
                tl: {
                    hd: BsCss_bs/* fontStyle */.p_N("normal"),
                    tl: {
                        hd: BsCss_bs/* display */.jfB("inlineBlock"),
                        tl: /* [] */ 0
                    }
                }
            }
        }
    }
});
var bodyText = curry._1(BsCss_bs/* style */.oBv, {
    hd: Theme_bs/* Typography.defaultFonts */.ZT.defaultFonts,
    tl: {
        hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(16)),
        tl: {
            hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(25)),
            tl: {
                hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.midGrey */.Il.midGrey),
                tl: {
                    hd: BsCss_bs/* fontWeight */.Ue2("normal"),
                    tl: {
                        hd: BsCss_bs/* fontStyle */.p_N("normal"),
                        tl: {
                            hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(10)),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }
    }
});
var ValueElement_bs_Styles = {
    container: ValueElement_bs_container,
    valueIcon: valueIcon,
    brandText: brandText,
    titleText: ValueElement_bs_titleText,
    bodyText: bodyText
};
function ValueElement(props) {
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsx("div", {
                children: jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                    src: props.valueIconUrl,
                    alt: "value icon",
                    width: 50,
                    height: 50
                }),
                className: valueIcon
            }),
            jsx_runtime.jsx("div", {
                children: props.brandText,
                className: brandText
            }),
            jsx_runtime.jsx("div", {
                children: props.titleText,
                className: ValueElement_bs_titleText
            }),
            jsx_runtime.jsx("div", {
                children: props.bodyText,
                className: bodyText
            })
        ],
        className: ValueElement_bs_container
    });
}
var ValueElement_bs_Img;
var ValueElement_bs_make = ValueElement;
 /* container Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/about/ourValue/AllValues.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




var AllValues_bs_wrapper = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* media */.BC2("(min-width: 768px)", {
        hd: BsCss_bs/* display */.jfB("flex"),
        tl: {
            hd: BsCss_bs/* justifyContent */.KlP("spaceBetween"),
            tl: /* [] */ 0
        }
    }),
    tl: {
        hd: BsCss_bs/* media */.BC2("(min-width: 1440px)", {
            hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(55.0)),
            tl: /* [] */ 0
        }),
        tl: {
            hd: BsCss_bs/* media */.BC2("(min-width: 768px) and (max-width: 1440px)", {
                hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(50.0)),
                tl: /* [] */ 0
            }),
            tl: /* [] */ 0
        }
    }
});
var AllValues_bs_leftContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* media */.BC2("(min-width: 768px)", {
        hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(45.0)),
        tl: /* [] */ 0
    }),
    tl: /* [] */ 0
});
var AllValues_bs_rightContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* media */.BC2("(min-width: 768px)", {
        hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(50)),
        tl: {
            hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(45.0)),
            tl: /* [] */ 0
        }
    }),
    tl: /* [] */ 0
});
var AllValues_bs_Styles = {
    wrapper: AllValues_bs_wrapper,
    leftContainer: AllValues_bs_leftContainer,
    rightContainer: AllValues_bs_rightContainer
};
function AllValues(props) {
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsx(ValueElement_bs_make, {
                        valueIconUrl: "/images/about/value/openness.svg",
                        brandText: "Give",
                        titleText: "openness",
                        bodyText: "We keep our minds and doors open to new possibilities."
                    }),
                    jsx_runtime.jsx(ValueElement_bs_make, {
                        valueIconUrl: "/images/about/value/magic.svg",
                        brandText: "Give",
                        titleText: "magic",
                        bodyText: "We're always thinking of ways to keep our customers wowed."
                    })
                ],
                className: AllValues_bs_leftContainer
            }),
            jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsx(ValueElement_bs_make, {
                        valueIconUrl: "/images/about/value/greatness.svg",
                        brandText: "Give",
                        titleText: "greatness",
                        bodyText: "We make it even more awesome by striving for excellence, always!"
                    }),
                    jsx_runtime.jsx(ValueElement_bs_make, {
                        valueIconUrl: "/images/about/value/damn.svg",
                        brandText: "Give",
                        titleText: "a damn",
                        bodyText: "We care enough to make this a great place to work."
                    })
                ],
                className: AllValues_bs_rightContainer
            })
        ],
        className: AllValues_bs_wrapper
    });
}
var AllValues_bs_make = AllValues;
 /* wrapper Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/about/ourValue/TeamPhoto.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




var TeamPhoto_bs_container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* media */.BC2("(min-width: 1440px)", {
        hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(30.0)),
        tl: /* [] */ 0
    }),
    tl: {
        hd: BsCss_bs/* media */.BC2("(min-width: 768px) and (max-width: 1439px)", {
            hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(40.0)),
            tl: /* [] */ 0
        }),
        tl: /* [] */ 0
    }
});
var TeamPhoto_bs_img = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("inlineBlock"),
    tl: /* [] */ 0
});
var TeamPhoto_bs_Styles = {
    container: TeamPhoto_bs_container,
    img: TeamPhoto_bs_img
};
function TeamPhoto(props) {
    return jsx_runtime.jsx("div", {
        children: jsx_runtime.jsx(StaticImage_bs/* make */.S, {
            src: "/images/about/value/team.png",
            alt: "team photo",
            width: 799,
            height: 863,
            className: TeamPhoto_bs_img
        }),
        className: TeamPhoto_bs_container
    });
}
var TeamPhoto_bs_Img;
var TeamPhoto_bs_make = TeamPhoto;
 /* container Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/about/ourValue/ValueHeader.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





var ValueHeader_bs_container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs.px(40)),
    tl: {
        hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(40)),
        tl: {
            hd: BsCss_bs/* media */.BC2("(min-width: 768px)", {
                hd: BsCss_bs/* width */.bf$(BsCss_bs.px(470)),
                tl: {
                    hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(100)),
                    tl: /* [] */ 0
                }
            }),
            tl: /* [] */ 0
        }
    }
});
var ValueHeader_bs_title = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(40)),
    tl: {
        hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(50)),
        tl: {
            hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.charcoal */.Il.charcoal),
            tl: {
                hd: BsCss_bs/* fontWeight */.Ue2("semiBold"),
                tl: {
                    hd: BsCss_bs/* fontStyle */.p_N("normal"),
                    tl: {
                        hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs.px(20)),
                        tl: {
                            hd: BsCss_bs/* media */.BC2("(max-width: 768px)", {
                                hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(32)),
                                tl: {
                                    hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(40)),
                                    tl: {
                                        hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs.px(12)),
                                        tl: /* [] */ 0
                                    }
                                }
                            }),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }
    }
});
var subTitle = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(16)),
    tl: {
        hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(25)),
        tl: {
            hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.midGrey */.Il.midGrey),
            tl: {
                hd: BsCss_bs/* fontWeight */.Ue2("normal"),
                tl: {
                    hd: BsCss_bs/* fontStyle */.p_N("normal"),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var ValueHeader_bs_Styles = {
    container: ValueHeader_bs_container,
    title: ValueHeader_bs_title,
    subTitle: subTitle
};
function ValueHeader(props) {
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsx(Text_bs_make, {
                children: "We're a team of givers, helpers & magic makers",
                className: ValueHeader_bs_title
            }),
            jsx_runtime.jsx(Text_bs_make, {
                children: "Our values demonstrate how we connect the heart and the head to collectively deliver on our strategic ambitions.",
                className: subTitle
            })
        ],
        className: ValueHeader_bs_container
    });
}
var ValueHeader_bs_make = ValueHeader;
 /* container Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/about/ourValue/OurValueSection.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE







var OurValueSection_bs_wrapper = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* backgroundColor */.Czw(Theme_bs/* Color.white */.Il.white),
    tl: {
        hd: BsCss_bs/* margin */.e6$(BsCss_bs.px(20)),
        tl: /* [] */ 0
    }
});
var OurValueSection_bs_container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* media */.BC2("(min-width: 768px)", {
        hd: BsCss_bs/* display */.jfB("flex"),
        tl: {
            hd: BsCss_bs/* justifyContent */.KlP("spaceBetween"),
            tl: /* [] */ 0
        }
    }),
    tl: /* [] */ 0
});
var OurValueSection_bs_Styles = {
    wrapper: OurValueSection_bs_wrapper,
    container: OurValueSection_bs_container
};
function OurValueSection(props) {
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsx(ValueHeader_bs_make, {}),
            jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsx(TeamPhoto_bs_make, {}),
                    jsx_runtime.jsx(AllValues_bs_make, {})
                ],
                className: OurValueSection_bs_container
            })
        ],
        className: OurValueSection_bs_wrapper
    });
}
var OurValueSection_bs_make = OurValueSection;
 /* wrapper Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/about/Heading1.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





var Heading1_bs_text = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(40)),
    tl: {
        hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(50)),
        tl: {
            hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.charcoal */.Il.charcoal),
            tl: {
                hd: BsCss_bs/* fontWeight */.Ue2("semiBold"),
                tl: {
                    hd: BsCss_bs/* fontStyle */.p_N("normal"),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var Heading1_bs_Styles = {
    text: Heading1_bs_text
};
function Heading1(props) {
    return jsx_runtime.jsx("h1", {
        children: props.children,
        className: belt_Option/* getWithDefault */.tj(props.className, Heading1_bs_text)
    });
}
var Heading1_bs_make = Heading1;
 /* text Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/bs-css-emotion/src/Css.bs.js + 7 modules
var Css_bs = __webpack_require__(90289);
// EXTERNAL MODULE: ./node_modules/bs-css/src/Css_Legacy_Core.bs.js
var Css_Legacy_Core_bs = __webpack_require__(68364);
;// CONCATENATED MODULE: ./src/components/pages/about/whoWeAre/ProductPanel.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE








var ProductPanel_bs_container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("block"),
    tl: {
        hd: BsCss_bs/* backgroundColor */.Czw(Theme_bs/* Color.paleGrey */.Il.paleGrey),
        tl: {
            hd: BsCss_bs/* borderRadius */.E0l(BsCss_bs.px(10)),
            tl: {
                hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(15)),
                tl: {
                    hd: BsCss_bs/* media */.BC2("(min-width: 768px)", {
                        hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(45.00)),
                        tl: {
                            hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(20)),
                            tl: {
                                hd: BsCss_bs/* marginRight */.wzR(BsCss_bs.px(20)),
                                tl: /* [] */ 0
                            }
                        }
                    }),
                    tl: {
                        hd: BsCss_bs/* media */.BC2("(min-width: 1024px)", {
                            hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(22.00)),
                            tl: {
                                hd: BsCss_bs/* marginRight */.wzR(BsCss_bs.px(40)),
                                tl: /* [] */ 0
                            }
                        }),
                        tl: /* [] */ 0
                    }
                }
            }
        }
    }
});
var ProductPanel_bs_innerContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* margin */.e6$(BsCss_bs.px(22)),
    tl: /* [] */ 0
});
var productIcon = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("block"),
    tl: {
        hd: BsCss_bs/* width */.bf$(BsCss_bs.px(45)),
        tl: {
            hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(45)),
            tl: {
                hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(16)),
                tl: {
                    hd: BsCss_bs/* borderRadius */.E0l(BsCss_bs/* pct */.hdZ(50.0)),
                    tl: {
                        hd: BsCss_bs/* boxShadow */.Wnp(Css_Legacy_Core_bs/* Shadow.box */.jXB.box(BsCss_bs.px(0), BsCss_bs.px(0), BsCss_bs.px(14), undefined, undefined, Css_bs/* rgba */.m4f(227, 11, 23, BsCss_bs/* pct */.hdZ(20.0)))),
                        tl: /* [] */ 0
                    }
                }
            }
        }
    }
});
var ProductPanel_bs_brandText = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(22)),
    tl: {
        hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(28)),
        tl: {
            hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.prezzeeRed */.Il.prezzeeRed),
            tl: {
                hd: BsCss_bs/* fontWeight */.Ue2("light"),
                tl: {
                    hd: BsCss_bs/* fontStyle */.p_N("normal"),
                    tl: {
                        hd: BsCss_bs/* display */.jfB("inlineBlock"),
                        tl: {
                            hd: BsCss_bs/* paddingRight */.WLm(BsCss_bs.px(5)),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }
    }
});
var ProductPanel_bs_titleText = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(22)),
    tl: {
        hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(28)),
        tl: {
            hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.charcoal */.Il.charcoal),
            tl: {
                hd: BsCss_bs/* fontWeight */.Ue2("semiBold"),
                tl: {
                    hd: BsCss_bs/* fontStyle */.p_N("normal"),
                    tl: {
                        hd: BsCss_bs/* display */.jfB("inlineBlock"),
                        tl: /* [] */ 0
                    }
                }
            }
        }
    }
});
var ProductPanel_bs_bodyText = curry._1(BsCss_bs/* style */.oBv, {
    hd: Theme_bs/* Typography.defaultFonts */.ZT.defaultFonts,
    tl: {
        hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(16)),
        tl: {
            hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(24)),
            tl: {
                hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.midGrey */.Il.midGrey),
                tl: {
                    hd: BsCss_bs/* fontWeight */.Ue2("normal"),
                    tl: {
                        hd: BsCss_bs/* fontStyle */.p_N("normal"),
                        tl: {
                            hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(8)),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }
    }
});
var ProductPanel_bs_Styles = {
    container: ProductPanel_bs_container,
    innerContainer: ProductPanel_bs_innerContainer,
    productIcon: productIcon,
    brandText: ProductPanel_bs_brandText,
    titleText: ProductPanel_bs_titleText,
    bodyText: ProductPanel_bs_bodyText
};
function ProductPanel(props) {
    var productIconUrl = props.productIconUrl;
    var productIcon_src = belt_Option/* getWithDefault */.tj(productIconUrl, "");
    return jsx_runtime.jsx("div", {
        children: jsx_runtime.jsxs("div", {
            children: [
                jsx_runtime.jsx("div", {
                    children: belt_Option/* mapWithDefault */.k7(productIconUrl, null, function(param) {
                        return jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                            src: productIcon_src,
                            alt: "product icon",
                            width: 73,
                            height: 73
                        });
                    }),
                    className: productIcon
                }),
                belt_Option/* mapWithDefault */.k7(props.brandText, null, function(text) {
                    return jsx_runtime.jsx("div", {
                        children: text,
                        className: ProductPanel_bs_brandText
                    });
                }),
                belt_Option/* mapWithDefault */.k7(props.titleText, null, function(text) {
                    return jsx_runtime.jsx("div", {
                        children: text,
                        className: ProductPanel_bs_titleText
                    });
                }),
                jsx_runtime.jsx("div", {
                    children: props.bodyText,
                    className: ProductPanel_bs_bodyText
                })
            ],
            className: ProductPanel_bs_innerContainer
        }),
        className: ProductPanel_bs_container
    });
}
var ProductPanel_bs_Img;
var ProductPanel_bs_make = ProductPanel;
 /* container Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/about/whoWeAre/WhoWeAreSection.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE









var WhoWeAreSection_bs_wrapper = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* backgroundColor */.Czw(Theme_bs/* Color.white */.Il.white),
    tl: {
        hd: BsCss_bs/* margin */.e6$(BsCss_bs.px(30)),
        tl: {
            hd: BsCss_bs/* media */.BC2("(max-width: 768px)", {
                hd: BsCss_bs/* marginLeft */.oIA(BsCss_bs.px(20)),
                tl: {
                    hd: BsCss_bs/* marginRight */.wzR(BsCss_bs.px(20)),
                    tl: /* [] */ 0
                }
            }),
            tl: {
                hd: BsCss_bs/* media */.BC2("(min-width: 1280px)", {
                    hd: BsCss_bs/* marginLeft */.oIA(BsCss_bs.px(0)),
                    tl: {
                        hd: BsCss_bs/* marginRight */.wzR(BsCss_bs.px(0)),
                        tl: /* [] */ 0
                    }
                }),
                tl: /* [] */ 0
            }
        }
    }
});
var WhoWeAreSection_bs_subTitle = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(16)),
    tl: {
        hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(25)),
        tl: {
            hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.midGrey */.Il.midGrey),
            tl: {
                hd: BsCss_bs/* fontWeight */.Ue2("normal"),
                tl: {
                    hd: BsCss_bs/* fontStyle */.p_N("normal"),
                    tl: {
                        hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs.px(35)),
                        tl: {
                            hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(10)),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }
    }
});
var productPanel = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("flex"),
    tl: {
        hd: BsCss_bs/* flexDirection */.Me8("row"),
        tl: {
            hd: BsCss_bs/* justifyContent */.KlP("flexStart"),
            tl: {
                hd: BsCss_bs/* media */.BC2("(max-width: 1023px)", {
                    hd: BsCss_bs/* flexWrap */.WOS("wrap"),
                    tl: {
                        hd: BsCss_bs/* justifyContent */.KlP("center"),
                        tl: /* [] */ 0
                    }
                }),
                tl: /* [] */ 0
            }
        }
    }
});
var WhoWeAreSection_bs_Styles = {
    wrapper: WhoWeAreSection_bs_wrapper,
    subTitle: WhoWeAreSection_bs_subTitle,
    productPanel: productPanel
};
function WhoWeAreSection(props) {
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsx(Heading1_bs_make, {
                children: "Who we are"
            }),
            jsx_runtime.jsx(Text_bs_make, {
                children: "Prezzee is a leading global eGift card platform with operations in North America, United Kingdom, Australia and New Zealand.",
                className: WhoWeAreSection_bs_subTitle
            }),
            jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsx(ProductPanel_bs_make, {
                        bodyText: "Every day gift giving made simple, personal and just right! Send a digital gift card from over 300 retail brands to friends and family around the world in seconds, " + (belt_Option/* getWithDefault */.tj(Localization_bs/* getLocalizedString */.Z("personalised"), "") + " with your own video!"),
                        brandText: "Prezzee",
                        productIconUrl: "/images/about/product/prezzee_classic.svg"
                    }),
                    jsx_runtime.jsx(ProductPanel_bs_make, {
                        bodyText: "Reward teams, say thanks to clients and " + (belt_Option/* getWithDefault */.tj(Localization_bs/* getLocalizedString */.Z("incentivise"), "") + (" customers with fast,  " + (belt_Option/* getWithDefault */.tj(Localization_bs/* getLocalizedString */.Z("customised"), "") + " gift cards sent in bulk, in a few minutes. Our clients include QBE, HSBC, Coca-Cola and 4,000 more! Corporate gifting has never been easier."))),
                        brandText: "Prezzee",
                        titleText: "Business",
                        productIconUrl: "/images/about/product/prezzee_business.svg"
                    }),
                    jsx_runtime.jsx(ProductPanel_bs_make, {
                        bodyText: "Seamlessly integrated via the Prezzee API, we help small and large businesses grow revenue and market share with a " + (belt_Option/* getWithDefault */.tj(Localization_bs/* getLocalizedString */.Z("customised"), "") + (" white-label marketplace featuring a  " + (belt_Option/* getWithDefault */.tj(Localization_bs/* getLocalizedString */.Z("catalogue"), "") + "  of 300+ eGift Cards."))),
                        brandText: "Prezzee",
                        titleText: "Marketplace",
                        productIconUrl: "/images/about/product/prezzee_marketplace.svg"
                    })
                ],
                className: productPanel
            })
        ],
        className: WhoWeAreSection_bs_wrapper
    });
}
var WhoWeAreSection_bs_make = WhoWeAreSection;
 /* wrapper Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/about/BodyText.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





var BodyText_bs_text = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(16)),
    tl: {
        hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(24)),
        tl: {
            hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.charcoal */.Il.charcoal),
            tl: {
                hd: BsCss_bs/* fontWeight */.Ue2("normal"),
                tl: {
                    hd: BsCss_bs/* fontStyle */.p_N("normal"),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var BodyText_bs_Styles = {
    text: BodyText_bs_text
};
function BodyText(props) {
    return jsx_runtime.jsx("h1", {
        children: props.children,
        className: belt_Option/* getWithDefault */.tj(props.className, BodyText_bs_text)
    });
}
var BodyText_bs_make = BodyText;
 /* text Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/about/ourJourney/YearFootPrint.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





var YearFootPrint_bs_container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs.px(240)),
    tl: /* [] */ 0
});
var YearFootPrint_bs_title = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(22)),
    tl: {
        hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(24)),
        tl: {
            hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.prezzeeRed */.Il.prezzeeRed),
            tl: {
                hd: BsCss_bs/* fontWeight */.Ue2("semiBold"),
                tl: {
                    hd: BsCss_bs/* fontStyle */.p_N("normal"),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var titleDiv = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("flex"),
    tl: {
        hd: BsCss_bs/* alignItems */.cq$("center"),
        tl: /* [] */ 0
    }
});
var YearFootPrint_bs_subTitle = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(16)),
    tl: {
        hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(24)),
        tl: {
            hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.charcoal */.Il.charcoal),
            tl: {
                hd: BsCss_bs/* fontWeight */.Ue2("semiBold"),
                tl: {
                    hd: BsCss_bs/* fontStyle */.p_N("normal"),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var YearFootPrint_bs_bodyText = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.midGrey */.Il.midGrey),
    tl: {
        hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(2)),
        tl: /* [] */ 0
    }
});
var YearFootPrint_bs_Styles = {
    container: YearFootPrint_bs_container,
    title: YearFootPrint_bs_title,
    titleDiv: titleDiv,
    subTitle: YearFootPrint_bs_subTitle,
    bodyText: YearFootPrint_bs_bodyText
};
function YearFootPrint(props) {
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsx("div", {
                children: jsx_runtime.jsx("h4", {
                    children: props.title,
                    className: YearFootPrint_bs_title
                }),
                className: titleDiv
            }),
            jsx_runtime.jsx(BodyText_bs_make, {
                children: props.subTitle,
                className: YearFootPrint_bs_subTitle
            }),
            jsx_runtime.jsx(BodyText_bs_make, {
                children: props.bodyText,
                className: YearFootPrint_bs_bodyText
            })
        ],
        className: YearFootPrint_bs_container
    });
}
var YearFootPrint_bs_make = YearFootPrint;
 /* container Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/about/ourJourney/Year2014.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




var Year2014_bs_container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* position */.FKU("absolute"),
    tl: {
        hd: BsCss_bs/* left */.t$v(BsCss_bs.px(94)),
        tl: {
            hd: BsCss_bs/* media */.BC2("(min-width: 1200px)", {
                hd: BsCss_bs/* left */.t$v(BsCss_bs.px(194)),
                tl: /* [] */ 0
            }),
            tl: /* [] */ 0
        }
    }
});
var Year2014_bs_Styles = {
    container: Year2014_bs_container
};
function Year2014(props) {
    return jsx_runtime.jsx("div", {
        children: jsx_runtime.jsx(YearFootPrint_bs_make, {
            title: "2014",
            subTitle: "Prezzee was founded",
            bodyText: "Prezzee was developed by Pollen Digital in collaboration with Shaun Bonett, Edward Piazza, Roger Hatem, Claire Morris, and Matt Hoggart, collectively Prezzee’s co-founders."
        }),
        className: Year2014_bs_container
    });
}
var Year2014_bs_make = Year2014;
 /* container Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/about/ourJourney/Year2016.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




var Year2016_bs_container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs.px(165)),
    tl: {
        hd: BsCss_bs/* position */.FKU("absolute"),
        tl: {
            hd: BsCss_bs/* bottom */.IaC(BsCss_bs.px(0)),
            tl: {
                hd: BsCss_bs/* left */.t$v(BsCss_bs.px(358)),
                tl: {
                    hd: BsCss_bs/* media */.BC2("(min-width: 1200px)", {
                        hd: BsCss_bs/* left */.t$v(BsCss_bs.px(458)),
                        tl: /* [] */ 0
                    }),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var Year2016_bs_Styles = {
    container: Year2016_bs_container
};
function Year2016(props) {
    return jsx_runtime.jsx("div", {
        children: jsx_runtime.jsx(YearFootPrint_bs_make, {
            title: "2016",
            subTitle: "Prezzee Business goes live",
            bodyText: "Making corporate gifting fun, flexible and fuss-free for businesses."
        }),
        className: Year2016_bs_container
    });
}
var Year2016_bs_make = Year2016;
 /* container Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/about/ourJourney/Year2018.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




var Year2018_bs_container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* position */.FKU("absolute"),
    tl: {
        hd: BsCss_bs/* left */.t$v(BsCss_bs.px(448)),
        tl: {
            hd: BsCss_bs/* media */.BC2("(min-width: 1200px)", {
                hd: BsCss_bs/* left */.t$v(BsCss_bs.px(548)),
                tl: /* [] */ 0
            }),
            tl: /* [] */ 0
        }
    }
});
var Year2018_bs_Styles = {
    container: Year2018_bs_container
};
function Year2018(props) {
    return jsx_runtime.jsx("div", {
        children: jsx_runtime.jsx(YearFootPrint_bs_make, {
            title: "2018",
            subTitle: "Prezzee Marketplace goes live",
            bodyText: "Helping companies increase loyalty, revenue and market share with our customised, white label API."
        }),
        className: Year2018_bs_container
    });
}
var Year2018_bs_make = Year2018;
 /* container Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/about/ourJourney/Year2020.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





var Year2020_bs_container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* position */.FKU("absolute"),
    tl: {
        hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(-35)),
        tl: {
            hd: BsCss_bs/* left */.t$v(BsCss_bs.px(719)),
            tl: {
                hd: BsCss_bs/* media */.BC2("(min-width: 1200px)", {
                    hd: BsCss_bs/* left */.t$v(BsCss_bs.px(819)),
                    tl: /* [] */ 0
                }),
                tl: /* [] */ 0
            }
        }
    }
});
var Year2020_bs_img = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("inlineBlock"),
    tl: {
        hd: BsCss_bs/* width */.bf$(BsCss_bs.px(100)),
        tl: {
            hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(45)),
            tl: /* [] */ 0
        }
    }
});
var Year2020_bs_Styles = {
    container: Year2020_bs_container,
    img: Year2020_bs_img
};
function Year2020(props) {
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                src: "/images/about/journey/flag1.png",
                alt: "flags icon",
                width: 100,
                height: 45,
                className: Year2020_bs_img
            }),
            jsx_runtime.jsx(YearFootPrint_bs_make, {
                title: "2020-2021",
                subTitle: "Prezzee goes global!",
                bodyText: "We launched in the UK, USA and New Zealand."
            })
        ],
        className: Year2020_bs_container
    });
}
var Year2020_bs_Img;
var Year2020_bs_make = Year2020;
 /* container Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/about/ourJourney/Year2024.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




var Year2024_bs_container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs.px(165)),
    tl: {
        hd: BsCss_bs/* position */.FKU("absolute"),
        tl: {
            hd: BsCss_bs/* bottom */.IaC(BsCss_bs.px(0)),
            tl: {
                hd: BsCss_bs/* right */.F2z(BsCss_bs.px(70)),
                tl: {
                    hd: BsCss_bs/* media */.BC2("(min-width: 1200px)", {
                        hd: BsCss_bs/* right */.F2z(BsCss_bs.px(170)),
                        tl: /* [] */ 0
                    }),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var Year2024_bs_Styles = {
    container: Year2024_bs_container
};
function Year2024(props) {
    return jsx_runtime.jsx("div", {
        children: jsx_runtime.jsx(YearFootPrint_bs_make, {
            title: "2024",
            subTitle: "Today",
            bodyText: "We become the official gifting partner of Afterpay and have over 800+ brands globally."
        }),
        className: Year2024_bs_container
    });
}
var Year2024_bs_make = Year2024;
 /* container Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/about/ourJourney/OneMillion.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





var OneMillion_bs_container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs.px(165)),
    tl: {
        hd: BsCss_bs/* position */.FKU("absolute"),
        tl: {
            hd: BsCss_bs/* bottom */.IaC(BsCss_bs.px(0)),
            tl: {
                hd: BsCss_bs/* left */.t$v(BsCss_bs.px(685)),
                tl: {
                    hd: BsCss_bs/* media */.BC2("(min-width: 1200px)", {
                        hd: BsCss_bs/* left */.t$v(BsCss_bs.px(785)),
                        tl: /* [] */ 0
                    }),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var imgWidth = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs.px(80)),
    tl: {
        hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(80)),
        tl: /* [] */ 0
    }
});
var OneMillion_bs_title = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(22)),
    tl: {
        hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(23)),
        tl: {
            hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.activeBlue */.Il.activeBlue),
            tl: {
                hd: BsCss_bs/* fontWeight */.Ue2("semiBold"),
                tl: {
                    hd: BsCss_bs/* fontStyle */.p_N("normal"),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var OneMillion_bs_subTitle = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(16)),
    tl: {
        hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(23)),
        tl: {
            hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.activeBlue */.Il.activeBlue),
            tl: {
                hd: BsCss_bs/* fontWeight */.Ue2("semiBold"),
                tl: {
                    hd: BsCss_bs/* fontStyle */.p_N("normal"),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var OneMillion_bs_Styles = {
    container: OneMillion_bs_container,
    imgWidth: imgWidth,
    title: OneMillion_bs_title,
    subTitle: OneMillion_bs_subTitle
};
function OneMillion(props) {
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsx("div", {
                children: jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                    src: "/images/about/journey/smart_card_1.png",
                    alt: "prezzee smart card",
                    width: 80,
                    height: 61
                }),
                className: imgWidth
            }),
            jsx_runtime.jsx("h4", {
                children: "ONE MILLION",
                className: OneMillion_bs_title
            }),
            jsx_runtime.jsx("h6", {
                children: "eGift cards sold! Milestone achieved.",
                className: OneMillion_bs_subTitle
            })
        ],
        className: OneMillion_bs_container
    });
}
var OneMillion_bs_Img;
var OneMillion_bs_make = OneMillion;
 /* container Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/about/ourJourney/FirstSmartCard.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





var FirstSmartCard_bs_wrapper = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs.px(165)),
    tl: {
        hd: BsCss_bs/* position */.FKU("absolute"),
        tl: {
            hd: BsCss_bs/* bottom */.IaC(BsCss_bs.px(0)),
            tl: {
                hd: BsCss_bs/* left */.t$v(BsCss_bs.px(140)),
                tl: {
                    hd: BsCss_bs/* media */.BC2("(min-width: 1200px)", {
                        hd: BsCss_bs/* left */.t$v(BsCss_bs.px(240)),
                        tl: /* [] */ 0
                    }),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var FirstSmartCard_bs_imgWidth = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs.px(80)),
    tl: {
        hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(80)),
        tl: /* [] */ 0
    }
});
var FirstSmartCard_bs_title = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(22)),
    tl: {
        hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(23)),
        tl: {
            hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.activeBlue */.Il.activeBlue),
            tl: {
                hd: BsCss_bs/* fontWeight */.Ue2("semiBold"),
                tl: {
                    hd: BsCss_bs/* fontStyle */.p_N("normal"),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var FirstSmartCard_bs_Styles = {
    wrapper: FirstSmartCard_bs_wrapper,
    imgWidth: FirstSmartCard_bs_imgWidth,
    title: FirstSmartCard_bs_title
};
function FirstSmartCard(props) {
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsx("div", {
                children: jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                    src: "/images/about/journey/smart_card_1.png",
                    alt: "prezzee smart card",
                    width: 80,
                    height: 61
                }),
                className: FirstSmartCard_bs_imgWidth
            }),
            jsx_runtime.jsx("h4", {
                children: "First Smart eGift Card Sold!",
                className: FirstSmartCard_bs_title
            })
        ],
        className: FirstSmartCard_bs_wrapper
    });
}
var FirstSmartCard_bs_Img;
var FirstSmartCard_bs_make = FirstSmartCard;
 /* wrapper Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
;// CONCATENATED MODULE: ./src/components/pages/about/ourJourney/OurJourneySection.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE














var OurJourneySection_bs_wrapper = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* media */.BC2("(min-width: 1200px)", {
        hd: BsCss_bs/* marginLeft */.oIA("auto"),
        tl: {
            hd: BsCss_bs/* marginRight */.wzR("auto"),
            tl: {
                hd: BsCss_bs/* display */.jfB("flex"),
                tl: {
                    hd: BsCss_bs/* overflowX */.zzh("scroll"),
                    tl: {
                        hd: Css_bs/* unsafe */.K47("-ms-overflow-style", "none"),
                        tl: {
                            hd: Css_bs/* unsafe */.K47("scrollbar-width", "none"),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }
    }),
    tl: /* [] */ 0
});
var OurJourneySection_bs_innerWrapper = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* maxWidth */.kkr(BsCss_bs.px(1406)),
    tl: {
        hd: BsCss_bs/* marginLeft */.oIA("auto"),
        tl: {
            hd: BsCss_bs/* marginRight */.wzR("auto"),
            tl: {
                hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(80)),
                tl: {
                    hd: BsCss_bs/* position */.FKU("relative"),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var headingDiv = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("flex"),
    tl: {
        hd: BsCss_bs/* alignItems */.cq$("center"),
        tl: {
            hd: BsCss_bs/* justifyContent */.KlP("spaceBetween"),
            tl: {
                hd: BsCss_bs/* margin */.e6$(BsCss_bs.px(30)),
                tl: {
                    hd: BsCss_bs/* media */.BC2("(max-width: 768px)", {
                        hd: BsCss_bs/* marginLeft */.oIA(BsCss_bs.px(20)),
                        tl: {
                            hd: BsCss_bs/* marginRight */.wzR(BsCss_bs.px(20)),
                            tl: /* [] */ 0
                        }
                    }),
                    tl: {
                        hd: BsCss_bs/* media */.BC2("(min-width: 1280px)", {
                            hd: BsCss_bs/* marginLeft */.oIA("auto"),
                            tl: {
                                hd: BsCss_bs/* marginRight */.wzR("auto"),
                                tl: {
                                    hd: BsCss_bs/* maxWidth */.kkr(BsCss_bs.px(1200)),
                                    tl: /* [] */ 0
                                }
                            }
                        }),
                        tl: /* [] */ 0
                    }
                }
            }
        }
    }
});
var headingText = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(40)),
    tl: {
        hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(50)),
        tl: {
            hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.charcoal */.Il.charcoal),
            tl: {
                hd: BsCss_bs/* fontWeight */.Ue2("semiBold"),
                tl: {
                    hd: BsCss_bs/* fontStyle */.p_N("normal"),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var swipeRightDiv = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(14)),
    tl: {
        hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(28)),
        tl: {
            hd: BsCss_bs/* letterSpacing */.rXp(BsCss_bs.px(2)),
            tl: {
                hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.prezzeeRed */.Il.prezzeeRed),
                tl: {
                    hd: BsCss_bs/* media */.BC2("(min-width: 1280px)", {
                        hd: BsCss_bs/* display */.jfB("none"),
                        tl: /* [] */ 0
                    }),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var aboutUsOurJourneyContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* overflowX */.zzh("scroll"),
    tl: {
        hd: Css_bs/* unsafe */.K47("-ms-overflow-style", "none"),
        tl: {
            hd: Css_bs/* unsafe */.K47("scrollbar-width", "none"),
            tl: /* [] */ 0
        }
    }
});
var OurJourneySection_bs_innerContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* backgroundImage */.NxW(BsCss_bs/* url */.HQ2("/images/about/journey/timeline.svg")),
    tl: {
        hd: BsCss_bs/* backgroundRepeat */.FDc("noRepeat"),
        tl: {
            hd: BsCss_bs/* backgroundPosition */.k0m("center"),
            tl: {
                hd: BsCss_bs/* position */.FKU("relative"),
                tl: {
                    hd: BsCss_bs/* marginLeft */.oIA("auto"),
                    tl: {
                        hd: BsCss_bs/* marginRight */.wzR("auto"),
                        tl: {
                            hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(30)),
                            tl: {
                                hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(30)),
                                tl: {
                                    hd: BsCss_bs/* media */.BC2("(max-width: 1199px)", {
                                        hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(405)),
                                        tl: {
                                            hd: BsCss_bs/* width */.bf$(BsCss_bs.px(1200)),
                                            tl: /* [] */ 0
                                        }
                                    }),
                                    tl: {
                                        hd: BsCss_bs/* media */.BC2("(min-width: 1200px)", {
                                            hd: BsCss_bs/* width */.bf$(BsCss_bs.px(1406)),
                                            tl: {
                                                hd: BsCss_bs/* minHeight */.jw4(BsCss_bs.px(405)),
                                                tl: /* [] */ 0
                                            }
                                        }),
                                        tl: /* [] */ 0
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
});
var leftLine = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("none"),
    tl: {
        hd: BsCss_bs/* media */.BC2("(min-width: 1200px)", {
            hd: BsCss_bs/* display */.jfB("flex"),
            tl: {
                hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(392)),
                tl: {
                    hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(25.0)),
                    tl: {
                        hd: BsCss_bs/* backgroundImage */.NxW(BsCss_bs/* url */.HQ2("/images/about/journey/left.svg")),
                        tl: {
                            hd: BsCss_bs/* backgroundRepeat */.FDc("noRepeat"),
                            tl: {
                                hd: BsCss_bs/* backgroundPosition */.k0m("right"),
                                tl: {
                                    hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(36)),
                                    tl: {
                                        hd: BsCss_bs/* marginRight */.wzR(BsCss_bs.px(-15)),
                                        tl: /* [] */ 0
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }),
        tl: /* [] */ 0
    }
});
var rightLine = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("none"),
    tl: {
        hd: BsCss_bs/* media */.BC2("(min-width: 1200px)", {
            hd: BsCss_bs/* display */.jfB("flex"),
            tl: {
                hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(392)),
                tl: {
                    hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(30.0)),
                    tl: {
                        hd: BsCss_bs/* backgroundImage */.NxW(BsCss_bs/* url */.HQ2("/images/about/journey/right.svg")),
                        tl: {
                            hd: BsCss_bs/* backgroundRepeat */.FDc("noRepeat"),
                            tl: {
                                hd: BsCss_bs/* backgroundPosition */.k0m("left"),
                                tl: {
                                    hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(35)),
                                    tl: {
                                        hd: BsCss_bs/* marginLeft */.oIA(BsCss_bs.px(-12)),
                                        tl: /* [] */ 0
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }),
        tl: /* [] */ 0
    }
});
var topRowContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* maxWidth */.kkr(BsCss_bs.px(1200)),
    tl: {
        hd: BsCss_bs/* display */.jfB("flex"),
        tl: /* [] */ 0
    }
});
var bottomRowContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* maxWidth */.kkr(BsCss_bs.px(1200)),
    tl: {
        hd: BsCss_bs/* display */.jfB("flex"),
        tl: /* [] */ 0
    }
});
var OurJourneySection_bs_Styles = {
    wrapper: OurJourneySection_bs_wrapper,
    innerWrapper: OurJourneySection_bs_innerWrapper,
    headingDiv: headingDiv,
    headingText: headingText,
    swipeRightDiv: swipeRightDiv,
    aboutUsOurJourneyContainer: aboutUsOurJourneyContainer,
    innerContainer: OurJourneySection_bs_innerContainer,
    leftLine: leftLine,
    rightLine: rightLine,
    topRowContainer: topRowContainer,
    bottomRowContainer: bottomRowContainer
};
function OurJourneySection(props) {
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsx(Heading1_bs_make, {
                        children: "Our journey",
                        className: headingText
                    }),
                    jsx_runtime.jsxs("div", {
                        children: [
                            "SWIPE",
                            jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                                icon: [
                                    "fas",
                                    "arrow-right"
                                ],
                                className: "ml-1"
                            })
                        ],
                        className: swipeRightDiv
                    })
                ],
                className: headingDiv
            }),
            jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsx("div", {
                        className: leftLine
                    }),
                    jsx_runtime.jsx("div", {
                        children: jsx_runtime.jsx("div", {
                            children: jsx_runtime.jsxs("div", {
                                children: [
                                    jsx_runtime.jsxs("div", {
                                        children: [
                                            jsx_runtime.jsx(Year2014_bs_make, {}),
                                            jsx_runtime.jsx(Year2018_bs_make, {}),
                                            jsx_runtime.jsx(Year2020_bs_make, {})
                                        ],
                                        className: topRowContainer
                                    }),
                                    jsx_runtime.jsxs("div", {
                                        children: [
                                            jsx_runtime.jsx(FirstSmartCard_bs_make, {}),
                                            jsx_runtime.jsx(Year2016_bs_make, {}),
                                            jsx_runtime.jsx(OneMillion_bs_make, {}),
                                            jsx_runtime.jsx(Year2024_bs_make, {})
                                        ],
                                        className: bottomRowContainer
                                    })
                                ],
                                className: OurJourneySection_bs_innerContainer
                            }),
                            className: aboutUsOurJourneyContainer,
                            id: "aboutUsOurJourneyContainer"
                        }),
                        className: OurJourneySection_bs_innerWrapper
                    }),
                    jsx_runtime.jsx("div", {
                        className: rightLine
                    })
                ],
                className: OurJourneySection_bs_wrapper,
                id: "aboutUsOurJourneyWrapper"
            })
        ]
    });
}
var OurJourneySection_bs_make = OurJourneySection;
 /* wrapper Not a pure module */ 

// EXTERNAL MODULE: ./src/components/enrichedTextSection/EnrichedTextSection.bs.js + 4 modules
var EnrichedTextSection_bs = __webpack_require__(94135);
// EXTERNAL MODULE: ./src/utils/PageContentResolver.bs.js
var PageContentResolver_bs = __webpack_require__(73763);
// EXTERNAL MODULE: ./src/components/pages/about/BoardOfDirectorsSection.bs.js
var BoardOfDirectorsSection_bs = __webpack_require__(95853);
// EXTERNAL MODULE: ./src/components/TrustpilotWidgetSection.bs.js + 2 modules
var TrustpilotWidgetSection_bs = __webpack_require__(22303);
;// CONCATENATED MODULE: ./src/pages/about.bs.js
__webpack_require__(14473);
// Generated by ReScript, PLEASE EDIT WITH CARE


















var whoWeAreContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* maxWidth */.kkr(BsCss_bs.px(1200)),
    tl: {
        hd: BsCss_bs/* backgroundColor */.Czw(Theme_bs/* Color.white */.Il.white),
        tl: {
            hd: BsCss_bs/* marginLeft */.oIA("auto"),
            tl: {
                hd: BsCss_bs/* marginRight */.wzR("auto"),
                tl: {
                    hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(63)),
                    tl: {
                        hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(63)),
                        tl: {
                            hd: BsCss_bs/* media */.BC2("(min-width: 768px) and (max-width: 1023px)", {
                                hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(58)),
                                tl: {
                                    hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(58)),
                                    tl: /* [] */ 0
                                }
                            }),
                            tl: {
                                hd: BsCss_bs/* media */.BC2("(min-width: 1024px) and (max-width: 1279px)", {
                                    hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(94)),
                                    tl: {
                                        hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(94)),
                                        tl: /* [] */ 0
                                    }
                                }),
                                tl: {
                                    hd: BsCss_bs/* media */.BC2("(min-width: 1280px) and (max-width: 1439px)", {
                                        hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(84)),
                                        tl: {
                                            hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(84)),
                                            tl: /* [] */ 0
                                        }
                                    }),
                                    tl: {
                                        hd: BsCss_bs/* media */.BC2("(min-width: 1440px)", {
                                            hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(97)),
                                            tl: {
                                                hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(97)),
                                                tl: /* [] */ 0
                                            }
                                        }),
                                        tl: /* [] */ 0
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
});
var about_bs_container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* maxWidth */.kkr(BsCss_bs.px(1200)),
    tl: {
        hd: BsCss_bs/* backgroundColor */.Czw(Theme_bs/* Color.white */.Il.white),
        tl: {
            hd: BsCss_bs/* marginLeft */.oIA("auto"),
            tl: {
                hd: BsCss_bs/* marginRight */.wzR("auto"),
                tl: {
                    hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(30)),
                    tl: {
                        hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(30)),
                        tl: /* [] */ 0
                    }
                }
            }
        }
    }
});
var about_bs_Styles = {
    whoWeAreContainer: whoWeAreContainer,
    container: about_bs_container
};
function About(props) {
    var pageContent = PageContentResolver_bs/* parse */.Qc(props.content);
    var f = function f(idx, v) {
        var key = String(idx);
        if (typeof v !== "object") {
            return null;
        }
        var variant = v.NAME;
        if (variant === "BoardOfDirectorsBlock") {
            return jsx_runtime.jsx(BoardOfDirectorsSection_bs/* make */.Sy, {
                block: v.VAL
            }, key);
        } else if (variant === "TrustpilotWidgetBlock") {
            return jsx_runtime.jsx(TrustpilotWidgetSection_bs/* make */.S, {
                block: v.VAL
            }, key);
        } else if (variant === "EnrichedTextBlock") {
            return jsx_runtime.jsx(EnrichedTextSection_bs/* make */.Sy, {
                block: v.VAL
            }, key);
        } else if (variant === "TeamMembersBlock") {
            return jsx_runtime.jsx(MeetTheTeam_bs/* make */.Sy, {
                block: v.VAL
            }, key);
        } else {
            return null;
        }
    };
    var content = pageContent !== undefined ? belt_Array/* mapWithIndex */.Su(pageContent.content_blocks, f) : null;
    var f_seo_meta = function f_seo_meta(v) {
        return jsx_runtime.jsx(SeoMeta_bs/* make */.S, {
            meta: v.VAL
        });
    };
    var seo_meta = pageContent !== undefined ? belt_Option/* mapWithDefault */.k7(pageContent.seo_meta, null, f_seo_meta) : null;
    return jsx_runtime.jsxs("div", {
        children: [
            seo_meta,
            jsx_runtime.jsx(make, {}),
            jsx_runtime.jsx("div", {
                children: jsx_runtime.jsx(WhoWeAreSection_bs_make, {}),
                className: whoWeAreContainer
            }),
            jsx_runtime.jsx(OurJourneySection_bs_make, {}),
            jsx_runtime.jsx(MediaSection_bs_make, {}),
            jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsx(OurValueSection_bs_make, {}),
                    jsx_runtime.jsx(AboutJoinTeam_bs_make, {})
                ],
                className: about_bs_container
            }),
            content
        ]
    });
}
var about_bs_make = About;
var $$default = About;
var __N_SSP = true;
 /* whoWeAreContainer Not a pure module */ 


/***/ }),

/***/ 47800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p5": function() { return /* binding */ ssr_page_cache; },
/* harmony export */   "yN": function() { return /* binding */ no_cache; }
/* harmony export */ });
/* unused harmony export product_ssr_page_cache */
// Generated by ReScript, PLEASE EDIT WITH CARE
var ssr_page_cache = "public, max-age=600, stale-while-revalidate=300, stale-if-error=1800";
var product_ssr_page_cache = "public, max-age=90, stale-while-revalidate=300, stale-if-error=1800";
var no_cache = "private, no-cache, no-store, max-age=0, must-revalidate";
 /* No side effect */ 


/***/ }),

/***/ 22303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ make; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/pages/index/IndexStyles.bs.js
var IndexStyles_bs = __webpack_require__(28848);
// EXTERNAL MODULE: ./node_modules/@emotion/css/dist/emotion-css.esm.js
var emotion_css_esm = __webpack_require__(97133);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/theme/foundations/colors.js
var colors = __webpack_require__(85171);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Responsive.bs.js
var Theme_Responsive_bs = __webpack_require__(70965);
;// CONCATENATED MODULE: ./src/utils/MutationObserverHook.ts

var defaultOptions = {
    attributes: true,
    childList: true,
    subtree: true
};
var useMutationObserver = function(targetRef, cb) {
    var config = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultOptions;
    var ref = (0,react.useState)(null), observer = ref[0], setObserver = ref[1];
    (0,react.useEffect)(function() {
        var obs = new MutationObserver(cb);
        setObserver(obs);
    }, [
        cb,
        config,
        setObserver
    ]);
    (0,react.useEffect)(function() {
        if (!observer || !targetRef.current) return;
        observer.observe(targetRef.current, config);
        return function() {
            if (observer) {
                observer.disconnect();
            }
        };
    }, [
        observer,
        targetRef,
        config
    ]);
};

// EXTERNAL MODULE: ./src/hooks/useSmartLink.tsx
var useSmartLink = __webpack_require__(12427);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/components/TrustpilotWidgetSection.tsx











var Styles = {
    section: function(top_distance, bottom_distance, hidden) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:", hidden ? "none" : "block", ";margin-top:", top_distance ? "".concat(top_distance, "px") : "0.75rem", ";margin-bottom:", bottom_distance ? "".concat(bottom_distance, "px") : "2.5rem", ";");
    },
    header: function(aligment) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("color:", colors["default"].gray[800], ";text-align:", aligment, ";font-weight:600;@media ", Theme_Responsive_bs/* desktop */.gv, "{margin-bottom:2rem;}@media ", Theme_Responsive_bs/* tabletOrMobile */.k$, "{margin-bottom:1.875rem;}");
    },
    h2: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-size:40px;line-height:50px;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{font-size:32px;line-height:40px;}"),
    h3: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-size:36px;line-height:46px;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{font-size:32px;line-height:42px;}"),
    h4: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-size:32px;line-height:42px;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{font-size:28px;line-height:38px;}")
};
var headerElements = {
    h2: "h2",
    h3: "h3",
    h4: "h4"
};
var TrustpilotWidgetSection = function(param) {
    var block = param.block;
    var title_text = block.title_text, title_alignment = block.title_alignment, title_heading = block.title_heading, widget_code = block.widget_code, smartLink = block.smartLink;
    var spotlightProps = (0,useSmartLink/* default */.Z)(smartLink);
    var widgetRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(true), isHidden = ref[0], setHidden = ref[1];
    var headerTag = headerElements[title_heading] ? headerElements[title_heading] : "h2";
    var Heading = headerTag;
    var onMutationChange = (0,react.useCallback)(function(mutation, observer) {
        if (widgetRef.current && widgetRef.current.querySelector("iframe")) {
            setHidden(false);
            observer.disconnect();
        }
    }, []);
    (0,react.useEffect)(function() {
        if (widgetRef.current && widgetRef.current.querySelector("iframe")) {
            setHidden(false);
        } else if (widgetRef.current && window.Trustpilot) {
            window.Trustpilot.loadFromElement(widgetRef.current.querySelector("div"));
            setHidden(false);
        }
    }, []);
    useMutationObserver(widgetRef, onMutationChange);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((script_default()), {
                type: "text/javascript",
                src: "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js",
                async: true
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("section", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: "".concat(IndexStyles_bs/* section */.qi, " ").concat(Styles.section(block.top_distance, block.bottom_distance, isHidden))
            }, spotlightProps), {
                children: [
                    title_text !== "" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Heading, {
                        className: "".concat(Styles[title_heading], " ").concat(Styles.header(title_alignment)),
                        children: title_text
                    }) : null,
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        ref: widgetRef,
                        dangerouslySetInnerHTML: {
                            __html: widget_code
                        }
                    })
                ]
            }))
        ]
    });
};
/* harmony default export */ var components_TrustpilotWidgetSection = (TrustpilotWidgetSection);

;// CONCATENATED MODULE: ./src/components/TrustpilotWidgetSection.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

var make = components_TrustpilotWidgetSection;
 /* make Not a pure module */ 


/***/ }),

/***/ 81036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Head */
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72491);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE






function SeoMeta(props) {
    var meta = props.meta;
    var router = next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter();
    var match = meta.seoMetaOgType.length;
    var ogType = match !== 0 ? meta.seoMetaOgType : "website";
    var ogImageAssetUrl = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .mapWithDefault */ .k7(meta.seoMetaOgImageAsset, "", function(b) {
        return b.url;
    });
    var twImageAssetUrl = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .map */ .UI(meta.seoMetaTwImageAsset, function(b) {
        return b.url;
    });
    var twImageUrl = twImageAssetUrl !== undefined ? twImageAssetUrl : meta.seoMetaTwImageAssetUrl;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
                title: meta.seoMetaBasicTitle,
                description: meta.seoMetaBasicDescription,
                canonical: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .SEOUtil.getCanonicalUrl */ .br.getCanonicalUrl(router.asPath),
                languageAlternates: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .SEOUtil.getLanguageAlternates */ .br.getLanguageAlternates(router.asPath),
                openGraph: {
                    title: meta.seoMetaOgTitle,
                    description: meta.seoMetaOgDescription,
                    url: meta.seoMetaOgUrl
                }
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: ogImageAssetUrl,
                        property: "og:image"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: ogType,
                        property: "og:type"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: meta.seoMetaTwTitle,
                        property: "twitter:title"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: meta.seoMetaTwDescription,
                        property: "twitter:description"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: "summary_large_image",
                        property: "twitter:card"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: router.pathname,
                        property: "twitter:url"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: twImageUrl,
                        property: "twitter:image"
                    })
                ]
            })
        ]
    });
}
var Head$1;
var make = SeoMeta;
 /* Util Not a pure module */ 


/***/ }),

/***/ 95853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports Link, BoardOfDirectorsCard, BoardOfDirectorsCarousel, BoardOfDirectorsList, SwiperSlide, KontentConsumer, Styles */
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(92592);
/* harmony import */ var _bindings_Fresnel_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7545);
/* harmony import */ var _CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34442);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(96533);
/* harmony import */ var _index_IndexStyles_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28848);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48929);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72721);
/* harmony import */ var _index_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26396);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70965);
/* harmony import */ var _prezzee_ribbon_src_components_personal_BoardOfDirectors_BoardOfDirectorsCard_bs_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(44599);
/* harmony import */ var _prezzee_ribbon_src_components_personal_BoardOfDirectors_BoardOfDirectorsList_bs_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(57458);
/* harmony import */ var _prezzee_ribbon_src_components_personal_BoardOfDirectors_BoardOfDirectorsCarousel_bs_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96705);
// Generated by ReScript, PLEASE EDIT WITH CARE















var outerContainer = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .position */ .FKU("relative"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginTop */ .E9m(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(5)),
        tl: /* [] */ 0
    }
});
var container = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .merge */ .TSy, {
    hd: _index_IndexStyles_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .section */ .qi,
    tl: {
        hd: _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .maxWidth */ .kkr(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(1240)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginTop */ .E9m(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(100)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingLeft */ .rv2(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20)),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingRight */ .WLm(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20)),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .belowLargeScreen */ .Qo, {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingLeft */ .rv2(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20)),
                                tl: {
                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingRight */ .WLm(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20)),
                                    tl: /* [] */ 0
                                }
                            }),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }),
        tl: /* [] */ 0
    }
});
var heading = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(40)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2({
            NAME: "num",
            VAL: 600
        }),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(50)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.25)),
                tl: /* [] */ 0
            }
        }
    }
});
var arrowStyles = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .top */ .wey("zero"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .right */ .F2z(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(30)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .position */ .FKU("absolute"),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .zIndex */ .W5D(10),
                tl: /* [] */ 0
            }
        }
    }
});
var cardGutter = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginRight */ .wzR(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(0.5)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(7)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .smallScreenOrMobile */ .HH, {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginRight */ .wzR(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(0)),
                tl: /* [] */ 0
            }),
            tl: /* [] */ 0
        }
    }
});
var listItem = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .maxWidth */ .kkr(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(650)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginLeft */ .oIA("auto"),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginRight */ .wzR("auto"),
            tl: /* [] */ 0
        }
    }
});
var Styles = {
    outerContainer: outerContainer,
    container: container,
    heading: heading,
    arrowStyles: arrowStyles,
    cardGutter: cardGutter,
    listItem: listItem
};
function BoardOfDirectorsSection(props) {
    var block = props.block;
    var smartLink = block.smartLink;
    var title = block.title;
    var blockTitle = title === "" ? null : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx("div", {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx("h2", {
            children: title,
            className: heading
        }),
        className: container
    });
    var boardOfDirectorsCards = _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_14__/* .map */ .UI(block.board_of_directors_cards, function(param) {
        var smartLink = param.smartLink;
        var link = param.link;
        var title = param.title;
        var name = param.name;
        var photo = param.photo;
        var img = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
            src: photo.url,
            alt: name,
            width: photo.width,
            height: photo.height,
            sizes: "" + _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .smallScreenOrMobile */ .HH + " 100vw, " + _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .tabletOrMobile */ .k$ + " 255px, 425px"
        });
        var card = link !== undefined ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            href: link,
            prefetch: false,
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx("a", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx(_prezzee_ribbon_src_components_personal_BoardOfDirectors_BoardOfDirectorsCard_bs_js__WEBPACK_IMPORTED_MODULE_10__/* .make */ .S, {
                    name: name,
                    title: title,
                    photo: img
                })
            })
        }) : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx(_prezzee_ribbon_src_components_personal_BoardOfDirectors_BoardOfDirectorsCard_bs_js__WEBPACK_IMPORTED_MODULE_10__/* .make */ .S, {
            name: name,
            title: title,
            photo: img
        });
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx(_index_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .make */ .S, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx("div", {
                children: card,
                className: cardGutter
            }),
            itemId: smartLink.itemId,
            elementCodename: smartLink.codename
        });
    });
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx(_index_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .make */ .S, {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .Consumer.make */ .$.make, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs("div", {
                children: [
                    blockTitle,
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
                        children: [
                            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx(_bindings_Fresnel_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Media.make */ .pU.make, {
                                lessThan: "md",
                                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx(_prezzee_ribbon_src_components_personal_BoardOfDirectors_BoardOfDirectorsList_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .make */ .S, {
                                    children: _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_14__/* .mapWithIndex */ .Su(boardOfDirectorsCards, function(idx, card) {
                                        var key = String(idx);
                                        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx("div", {
                                            children: card,
                                            className: listItem
                                        }, key);
                                    })
                                })
                            }),
                            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx(_bindings_Fresnel_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Media.make */ .pU.make, {
                                greaterThanOrEqual: "md",
                                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx(_prezzee_ribbon_src_components_personal_BoardOfDirectors_BoardOfDirectorsCarousel_bs_js__WEBPACK_IMPORTED_MODULE_12__/* .make */ .Sy, {
                                    children: _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_14__/* .mapWithIndex */ .Su(boardOfDirectorsCards, function(idx, card) {
                                        var key = String(idx);
                                        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .SwiperSlide */ .o5, {
                                            children: card
                                        }, key);
                                    }),
                                    arrowStyles: arrowStyles
                                })
                            })
                        ]
                    })
                ],
                className: outerContainer
            })
        }),
        itemId: smartLink.itemId,
        elementCodename: smartLink.codename
    });
}
var Link$1;
var BoardOfDirectorsCard;
var BoardOfDirectorsCarousel;
var BoardOfDirectorsList;
var SwiperSlide;
var KontentConsumer;
var make = BoardOfDirectorsSection;
 /* outerContainer Not a pure module */ 


/***/ }),

/***/ 3336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports Link, Styles */
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(92592);
/* harmony import */ var _CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34442);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(96533);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(25400);
/* harmony import */ var _index_IndexStyles_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28848);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72721);
/* harmony import */ var _index_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26396);
/* harmony import */ var _prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78078);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17845);
/* harmony import */ var _prezzee_ribbon_src_components_personal_TeamMembers_TeamMemberCard_bs_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95664);
/* harmony import */ var _prezzee_ribbon_src_components_personal_TeamMembers_TeamMembersBlock_bs_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47177);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE
















var section = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_12__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .merge */ .TSy, {
    hd: _index_IndexStyles_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .section */ .qi,
    tl: {
        hd: _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_12__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .maxWidth */ .kkr(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(1240)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginTop */ .E9m(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(100)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingLeft */ .rv2(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20)),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingRight */ .WLm(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20)),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .belowLargeScreen */ .Qo, {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingLeft */ .rv2(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20)),
                                tl: {
                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingRight */ .WLm(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20)),
                                    tl: /* [] */ 0
                                }
                            }),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }),
        tl: /* [] */ 0
    }
});
var heading = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_12__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2("semiBold"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .Personal.charcoal */ .RL.charcoal),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(28)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(36)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7("zero"),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .desktop */ .gv, {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(40)),
                            tl: {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(50)),
                                tl: {
                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7("zero"),
                                    tl: /* [] */ 0
                                }
                            }
                        }),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .tablet */ .Mq, {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(36)),
                                tl: {
                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(46)),
                                    tl: {
                                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7("zero"),
                                        tl: /* [] */ 0
                                    }
                                }
                            }),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }
    }
});
var Styles = {
    section: section,
    heading: heading
};
function MeetTheTeam(props) {
    var block = props.block;
    var smartLink = block.smartLink;
    var title = block.title;
    var blockTitle = title === "" ? null : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("h2", {
        children: title,
        className: heading
    });
    var perRow;
    switch(block.cards_per_row){
        case "five":
            perRow = /* Five */ 2;
            break;
        case "four":
            perRow = /* Four */ 1;
            break;
        case "three":
            perRow = /* Three */ 0;
            break;
        default:
            perRow = /* Four */ 1;
    }
    var cards = _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_13__/* .mapWithIndex */ .Su(block.team_member_cards, function(idx, cardContent) {
        var key = String(idx);
        var smartLink = cardContent.smartLink;
        var link = cardContent.link;
        var name = cardContent.name;
        var photo_front = cardContent.photo_front;
        var photoFront = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S, {
            src: photo_front.url,
            alt: name,
            width: photo_front.width,
            height: photo_front.height,
            sizes: "" + _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .tabletSm */ .FV + " 100vw, " + _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .tabletOrMobile */ .k$ + " 482px, 286px"
        });
        var photoBack = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_14__/* .mapWithDefault */ .k7(cardContent.photo_back, undefined, function(pb) {
            return _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_15__/* .some */ .G(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S, {
                src: pb.url,
                alt: name,
                width: pb.width,
                height: pb.height,
                sizes: "" + _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .tabletSm */ .FV + " 100vw, " + _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .tabletOrMobile */ .k$ + " 482px, 286px"
            }));
        });
        var nameEl = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("h2", {
            children: name
        });
        var titleEl = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("h2", {
            children: cardContent.title
        });
        var descEl = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_7__.make, {
            children: cardContent.description
        });
        var card = link !== undefined ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: link,
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("a", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_personal_TeamMembers_TeamMemberCard_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .make */ .Sy, {
                    photoFront: photoFront,
                    photoBack: photoBack,
                    name: nameEl,
                    title: titleEl,
                    description: descEl
                })
            })
        }) : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_personal_TeamMembers_TeamMemberCard_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .make */ .Sy, {
            photoFront: photoFront,
            photoBack: photoBack,
            name: nameEl,
            title: titleEl,
            description: descEl
        });
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_index_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .make */ .S, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .Consumer.make */ .$.make, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("div", {
                    children: card
                })
            }),
            itemId: smartLink.itemId,
            elementCodename: smartLink.codename
        }, key);
    });
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_index_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .make */ .S, {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .Consumer.make */ .$.make, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs("section", {
                children: [
                    blockTitle,
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_personal_TeamMembers_TeamMembersBlock_bs_js__WEBPACK_IMPORTED_MODULE_10__/* .make */ .S, {
                        children: cards,
                        perRow: perRow
                    })
                ],
                className: section
            })
        }),
        itemId: smartLink.itemId,
        elementCodename: smartLink.codename
    });
}
var Link$1;
var make = MeetTheTeam;
 /* section Not a pure module */ 


/***/ }),

/***/ 98765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getLocalizedString; }
/* harmony export */ });
/* unused harmony exports MapString, au, us, uk, nz */
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _rescript_std_lib_es6_belt_MapString_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93995);
// Generated by ReScript, PLEASE EDIT WITH CARE


var au = _rescript_std_lib_es6_belt_MapString_js__WEBPACK_IMPORTED_MODULE_1__/* .fromArray */ .nI([
    [
        "region",
        "AU"
    ],
    [
        "companyName",
        "Prezzee Pty Ltd"
    ],
    [
        "registration",
        "ABN 16602963422"
    ],
    [
        "supportEmail",
        "help@prezzee.com"
    ],
    [
        "corporateEmail",
        "corporate@prezzee.com.au"
    ],
    [
        "phoneNumber",
        "+61 2 9093 2777"
    ],
    [
        "phoneNumberWithoutCountryCode",
        "1800 940 868"
    ],
    [
        "address",
        "Level 3, 9 Castlereagh Street, Sydney, NSW 2000"
    ],
    [
        "personalise",
        "personalise"
    ],
    [
        "Personalise",
        "Personalise"
    ],
    [
        "personalised",
        "personalised"
    ],
    [
        "incentivise",
        "incentivise"
    ],
    [
        "organisations",
        "organisations"
    ],
    [
        "damn",
        "damn"
    ],
    [
        "energised",
        "energised"
    ],
    [
        "customised",
        "customised"
    ],
    [
        "catalogue",
        "catalogue"
    ],
    [
        "apologise",
        "apologise"
    ],
    [
        "riskLink",
        "https://help.prezzee.com.au/hc/en-us/requests/new?ticket_form_id=505267"
    ]
]);
var us = _rescript_std_lib_es6_belt_MapString_js__WEBPACK_IMPORTED_MODULE_1__/* .fromArray */ .nI([
    [
        "region",
        "US"
    ],
    [
        "companyName",
        "Prezzee Inc"
    ],
    [
        "registration",
        ""
    ],
    [
        "supportEmail",
        "help@prezzee.com"
    ],
    [
        "corporateEmail",
        "corporate@prezzee.com"
    ],
    [
        "phoneNumber",
        "+1 (833) 300-0982"
    ],
    [
        "phoneNumberWithoutCountryCode",
        "(833) 300-0982"
    ],
    [
        "address",
        "1411 Broadway, New York, NY 10018"
    ],
    [
        "personalise",
        "personalize"
    ],
    [
        "Personalise",
        "Personalize"
    ],
    [
        "personalised",
        "personalized"
    ],
    [
        "incentivise",
        "incentivize"
    ],
    [
        "organisations",
        "organizations"
    ],
    [
        "damn",
        ""
    ],
    [
        "energised",
        "energized"
    ],
    [
        "customised",
        "customized"
    ],
    [
        "catalogue",
        "catalog"
    ],
    [
        "apologise",
        "apologize"
    ],
    [
        "riskLink",
        "https://prezzeeus.zendesk.com/hc/en-us/requests/new?ticket_form_id=505267"
    ]
]);
var uk = _rescript_std_lib_es6_belt_MapString_js__WEBPACK_IMPORTED_MODULE_1__/* .fromArray */ .nI([
    [
        "region",
        "UK"
    ],
    [
        "companyName",
        "Prezzee UK"
    ],
    [
        "registration",
        "CRN 12851966"
    ],
    [
        "supportEmail",
        "help@prezzee.com"
    ],
    [
        "corporateEmail",
        "corporate@prezzee.com"
    ],
    [
        "phoneNumber",
        "+44 808 164 9223"
    ],
    [
        "phoneNumberWithoutCountryCode",
        "0808 164 9223"
    ],
    [
        "address",
        "49 Greek Street London, W1D 4EG. UK"
    ],
    [
        "personalise",
        "personalise"
    ],
    [
        "Personalise",
        "Personalise"
    ],
    [
        "personalised",
        "personalised"
    ],
    [
        "incentivise",
        "incentivise"
    ],
    [
        "organisations",
        "organisations"
    ],
    [
        "damn",
        "damn"
    ],
    [
        "energised",
        "energised"
    ],
    [
        "catalogue",
        "catalogue"
    ],
    [
        "apologise",
        "apologise"
    ],
    [
        "riskLink",
        "https://prezzeeuk.zendesk.com/hc/en-us/requests/new?ticket_form_id=505267"
    ]
]);
var nz = _rescript_std_lib_es6_belt_MapString_js__WEBPACK_IMPORTED_MODULE_1__/* .fromArray */ .nI([
    [
        "region",
        "NZ"
    ],
    [
        "companyName",
        "Prezzee Limited"
    ],
    [
        "registration",
        "NZBN 9429049008357"
    ],
    [
        "supportEmail",
        "help@prezzee.com"
    ],
    [
        "corporateEmail",
        "corporate@prezzee.co.nz"
    ],
    [
        "phoneNumber",
        "+64 800 627 040"
    ],
    [
        "phoneNumberWithoutCountryCode",
        "0800 627 040"
    ],
    [
        "address",
        "Level 3, 9 Castlereagh Street, Sydney, NSW 2000"
    ],
    [
        "personalise",
        "personalise"
    ],
    [
        "Personalise",
        "Personalise"
    ],
    [
        "personalised",
        "personalised"
    ],
    [
        "incentivise",
        "incentivise"
    ],
    [
        "organisations",
        "organisations"
    ],
    [
        "energised",
        "energised"
    ],
    [
        "damn",
        "damn"
    ],
    [
        "customised",
        "customised"
    ],
    [
        "catalogue",
        "catalogue"
    ],
    [
        "apologise",
        "apologise"
    ],
    [
        "riskLink",
        "https://prezzeenz.zendesk.com/hc/en-us/requests/new?ticket_form_id=505267"
    ]
]);
function getLocalizedString(str) {
    var match = _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.currentCountry */ .i3.currentCountry;
    if (match.TAG !== /* Ok */ 0) {
        return _rescript_std_lib_es6_belt_MapString_js__WEBPACK_IMPORTED_MODULE_1__/* .get */ .U2(au, str);
    }
    switch(match._0){
        case /* GreatBritain */ 1:
            return _rescript_std_lib_es6_belt_MapString_js__WEBPACK_IMPORTED_MODULE_1__/* .get */ .U2(uk, str);
        case /* UnitedStates */ 2:
            return _rescript_std_lib_es6_belt_MapString_js__WEBPACK_IMPORTED_MODULE_1__/* .get */ .U2(us, str);
        case /* NewZealand */ 3:
            return _rescript_std_lib_es6_belt_MapString_js__WEBPACK_IMPORTED_MODULE_1__/* .get */ .U2(nz, str);
        case /* Australia */ 0:
        case /* Canada */ 4:
            return _rescript_std_lib_es6_belt_MapString_js__WEBPACK_IMPORTED_MODULE_1__/* .get */ .U2(au, str);
    }
}
var MapString;
 /* au Not a pure module */ 


/***/ }),

/***/ 73763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qc": function() { return /* binding */ parse; },
/* harmony export */   "UW": function() { return /* binding */ resolver; }
/* harmony export */ });
/* unused harmony export modifyBlocks */
/* harmony import */ var _glennsl_bs_json_src_Json_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57687);
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7667);
/* harmony import */ var _api_graphql_CmsData_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(607);
/* harmony import */ var _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43437);
/* harmony import */ var _rescript_std_lib_es6_js_null_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94518);
/* harmony import */ var _common_Constants_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47800);
/* harmony import */ var _rescript_std_lib_es6_js_string_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37712);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96533);
/* harmony import */ var _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27097);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(25400);
/* harmony import */ var _api_queries_modifyBlocks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23328);
// Generated by ReScript, PLEASE EDIT WITH CARE












function modifyBlocks(prim0, prim1, prim2) {
    return ModifyBlocks.modifyBlocks(prim0, prim1, prim2);
}
function resolver(ctx, url, param) {
    if (_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .isNone */ .Wi(_rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_5__/* .get */ .U2(ctx.query, "preview"))) {
        ctx.res.setHeader("Cache-Control", _common_Constants_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .ssr_page_cache */ .p5);
    }
    var isPreview = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .isSome */ .pC(_rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_5__/* .get */ .U2(ctx.query, "preview"));
    var i = _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_5__/* .get */ .U2(ctx.query, "lang");
    var language = i !== undefined ? i : null;
    var path = _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_7__/* .get */ .U2(_rescript_std_lib_es6_js_string_js__WEBPACK_IMPORTED_MODULE_8__/* .split */ .Vl("?", ctx.resolvedUrl), 0);
    var queryUrl = url !== undefined ? url : path !== undefined ? path : "";
    return _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_9__/* .then_ */ .k(function(res) {
        var content = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .flatMap */ .VS(res, function(p) {
            return p.content;
        });
        var result = _rescript_std_lib_es6_js_null_js__WEBPACK_IMPORTED_MODULE_10__/* .fromOption */ .Yo(JSON.stringify(content));
        return _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_9__/* .then_ */ .k(function(modifiedResult) {
            return Promise.resolve({
                props: {
                    content: modifiedResult
                }
            });
        }, _api_queries_modifyBlocks__WEBPACK_IMPORTED_MODULE_3__/* .modifyBlocks */ .IN(result, isPreview, _common_util_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .EnvUtil.getCmsLanguage */ .i3.getCmsLanguage(language)));
    }, _api_graphql_CmsData_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .getPageContent */ .nW(_common_util_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .EnvUtil.getCmsLanguage */ .i3.getCmsLanguage(language), isPreview, queryUrl));
}
function parse(data) {
    return _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .map */ .UI(data == null ? undefined : _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_11__/* .some */ .G(data), _glennsl_bs_json_src_Json_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .parseOrRaise */ .YF);
}
 /* Util Not a pure module */ 


/***/ }),

/***/ 78078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "make": function() { return /* binding */ make; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE

function RichText(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("div", {
        className: className$1,
        dangerouslySetInnerHTML: {
            __html: props.children
        }
    });
}
var make = RichText;
 /* react/jsx-runtime Not a pure module */ 


/***/ }),

/***/ 95664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports Styles, Photos */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72491);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17845);
/* harmony import */ var _theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32567);
// Generated by ReScript, PLEASE EDIT WITH CARE






var card = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .merge */ .TSy([
    _theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .Styles.body */ .z.body,
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginTop */ .E9m(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(30))
    ])
]);
var photo = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .position */ .FKU("relative"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .selector */ .nZE("img", [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .objectFit */ .fXf("contain"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .pct */ .hdZ(100)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .display */ .jfB("block")
    ])
]);
var photoFront = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .selector */ .nZE("img", [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .height */ .Cb8("auto")
    ])
]);
var hoverEffect = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .position */ .FKU("relative"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .zIndex */ .W5D(2),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .opacity */ .Ohi(1),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .selector */ .nZE("&:hover", [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .opacity */ .Ohi(0)
    ])
]);
var photoBack = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .position */ .FKU("absolute"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .zIndex */ .W5D(1),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .left */ .t$v("zero"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .top */ .wey("zero"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .pct */ .hdZ(100)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .height */ .Cb8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .pct */ .hdZ(100)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .selector */ .nZE("img", [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .height */ .Cb8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .pct */ .hdZ(100))
    ])
]);
var text = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginTop */ .E9m(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(22))
]);
var name = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_Y(_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .Personal.primaryRed */ .RL.primaryRed),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .children */ .pIy([
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(1.25)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(1.75)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue2("light"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .margin */ .e6$("zero"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .textDecoration */ .QXS("none")
    ])
]);
var title = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_Y(_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .Personal.charcoal */ .RL.charcoal),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .children */ .pIy([
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(1.25)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(1.75)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue2("semiBold"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .margin */ .e6$("zero"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .textDecoration */ .QXS("none")
    ])
]);
var description = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_Y(_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .Personal.midGrey */ .RL.midGrey),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .selector */ .nZE("p", [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginTop */ .E9m(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(6)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginBottom */ .yl7("zero")
    ])
]);
var Styles = {
    card: card,
    photo: photo,
    photoFront: photoFront,
    hoverEffect: hoverEffect,
    photoBack: photoBack,
    text: text,
    name: name,
    title: title,
    description: description
};
function TeamMemberCard$Photos(props) {
    var photoBack$1 = props.photoBack;
    var hoverPhoto = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .mapWithDefault */ .k7(photoBack$1, null, function(pb) {
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
            children: pb,
            className: photoBack
        });
    });
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs("div", {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
                children: props.photoFront,
                className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
                    photoFront,
                    _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .isSome */ .pC(photoBack$1) ? hoverEffect : ""
                ])
            }),
            hoverPhoto
        ],
        className: photo
    });
}
var Photos = {
    make: TeamMemberCard$Photos
};
function TeamMemberCard(props) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs("div", {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(TeamMemberCard$Photos, {
                photoFront: props.photoFront,
                photoBack: props.photoBack
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs("div", {
                children: [
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
                        children: props.name,
                        className: name
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
                        children: props.title,
                        className: title
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
                        children: props.description,
                        className: description
                    })
                ],
                className: text
            })
        ],
        className: card
    });
}
var make = TeamMemberCard;
 /* card Not a pure module */ 


/***/ }),

/***/ 47177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE




var container = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .display */ .jfB("grid"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .gridTemplateColumns */ .K$K([
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.fr(1)
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .gridTemplateRows */ .RGf([
        "auto"
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .tabletSmUp */ .Uv, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .gridTemplateColumns */ .K$K([
            {
                NAME: "repeat",
                VAL: [
                    {
                        NAME: "num",
                        VAL: 2
                    },
                    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.fr(1)
                ]
            }
        ]),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .gridColumnGap */ .W3B(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .pct */ .hdZ(2))
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .desktop */ .gv, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .gridColumnGap */ .W3B(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .pct */ .hdZ(1))
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .selector */ .nZE("a", [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .textDecoration */ .QXS("none")
    ])
]);
var threePerRow = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .desktop */ .gv, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .gridTemplateColumns */ .K$K([
            {
                NAME: "repeat",
                VAL: [
                    {
                        NAME: "num",
                        VAL: 3
                    },
                    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.fr(1)
                ]
            }
        ])
    ])
]);
var fourPerRow = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .desktop */ .gv, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .gridTemplateColumns */ .K$K([
            {
                NAME: "repeat",
                VAL: [
                    {
                        NAME: "num",
                        VAL: 4
                    },
                    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.fr(1)
                ]
            }
        ])
    ])
]);
var fivePerRow = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .desktop */ .gv, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .gridTemplateColumns */ .K$K([
            {
                NAME: "repeat",
                VAL: [
                    {
                        NAME: "num",
                        VAL: 5
                    },
                    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.fr(1)
                ]
            }
        ])
    ])
]);
var Styles = {
    container: container,
    threePerRow: threePerRow,
    fourPerRow: fourPerRow,
    fivePerRow: fivePerRow
};
function TeamMembersBlock(props) {
    var perRow = props.perRow;
    var perRow$1 = perRow !== undefined ? perRow : /* Four */ 1;
    var perRowClass;
    switch(perRow$1){
        case /* Three */ 0:
            perRowClass = threePerRow;
            break;
        case /* Four */ 1:
            perRowClass = fourPerRow;
            break;
        case /* Five */ 2:
            perRowClass = fivePerRow;
            break;
    }
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: props.children,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            container,
            perRowClass
        ])
    });
}
var make = TeamMembersBlock;
 /* container Not a pure module */ 


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3995,8929,8687,7035,4135,9774,2888,179], function() { return __webpack_exec__(33216); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);